import {
  ABSENCE_OPTION_CONTENT,
  ANOMALY_LABELS,
  APP_EVENTS,
  APP_VIEWS,
  APP_VIEW_REGISTRY,
  ARCHIVE_COPY_GRACE_MINUTES,
  ASSISTANT_WAITING_TIMEOUT_MS,
  AUTO_FILL_TASK_MEMO,
  AUTO_FILL_TASK_TITLE,
  AttachmentType,
  BUDGET_TYPE_LABELS,
  BUG_REPORT_PROCESSED_STATUSES,
  BUG_REPORT_QUEST_TEAM_NAME,
  BugReportAttachmentSchema,
  BugReportEventType,
  BugReportStatus,
  BugReportType,
  CAMPAIGN_RETRO_LESSON,
  CANCEL_WAIT_MS,
  CANDIDATE_CONTACT_STATES,
  CHAIN_OPEN_WHERE,
  CHECKPOINT_REVISION_FIELDS,
  CHECKPOINT_TRANSITIONS,
  CLUB_DURATION_CAP_MS,
  CLUB_TINT_PALETTE,
  CONDITION_AGREED_EVENT,
  CONSISTENCY_RULES,
  CREATOR_MAIL_DRAFT_HEARTBEAT_MS,
  CREATOR_MAIL_DRAFT_LEASE_MS,
  CampaignVideoReviewVerdict,
  CapabilityPermissionModifiers,
  CheckpointRevisionKind,
  CheckpointStatus,
  CheckpointType,
  ClubFeedStatus,
  ClubPollStatus,
  ConversationEntityType,
  CreateKnowledgeAuthorityDecisionSchema,
  CreateKnowledgeSourceSchema,
  DEFAULT_AGENT_SLUG,
  DIVIDEND_POOL_RATE,
  DOKKAEBI_EVENTS,
  DOKKAEBI_PROACTIVE_TITLE_PREFIX,
  DOMESTIC_QUEUE_TAB_STATUS,
  DRAFT_REVIEW_ROUND_RISK_THRESHOLD,
  EXCLUSION_LOCK_LEAD_MS,
  FIRST_CONTRACT_VIDEO_NO,
  FLEX_WEEKLY_WORK_THRESHOLD_MS,
  GetKnowledgeDocumentQuerySchema,
  GuidelineReviewItemKind,
  INFO_SCORE,
  KNOWLEDGE_AUTHORITY_STATUSES,
  KNOWLEDGE_DOCUMENT_AVAILABILITIES,
  KNOWLEDGE_INDEXING_STATUSES,
  KNOWLEDGE_INDEX_STATES,
  KNOWLEDGE_INITIAL_CHUNKER_VERSION,
  KNOWLEDGE_INITIAL_EXTRACTOR_VERSION,
  KNOWLEDGE_SOURCE_MEMBER_ROLES,
  KNOWLEDGE_SYNC_JOB_STATES,
  KnowledgeIndexConfigSchema,
  KnowledgeSourceMemberSchema,
  LEGACY_CHECKPOINT_STATUS,
  LINKED_CHAIN_OPEN_WHERE,
  MANAGER_BONUS_REASON_MESSAGE,
  MCP_FINANCIAL_WRITE_SCOPES,
  MCP_IMPERSONATE_SCOPE,
  MCP_SCOPES,
  MCP_SCOPE_ISSUE_REQUIREMENTS,
  MCP_SCOPE_PERMISSIONS,
  MCP_SCOPE_PRESETS,
  MCP_TOKEN_PREFIX,
  MCP_TOKEN_RANDOM_BYTES,
  MUST_FIX_SCORE,
  ManagerBonusReasonCode,
  ManagerBonusSkipReason,
  NARRATOR_AGENT_SLUG,
  NOTIFICATION_SCOPES,
  NOTIFICATION_TYPES,
  OAUTH_AUTHORIZATION_CODE_TTL_SECONDS,
  OAUTH_AUTHORIZE_REQUEST_TTL_SECONDS,
  OAUTH_OFFLINE_ACCESS_SCOPE,
  OAUTH_REFRESH_TOKEN_PREFIX,
  OAUTH_REFRESH_TOKEN_TTL_SECONDS,
  ONBOARDING_ALLOWED_VIEWS,
  OUTREACH_BLOCKING_VARIABLES,
  OUTREACH_SUPPRESSION_REASONS,
  PERFORMANCE_REPORT_ANCHOR_DAYS,
  PERFORMANCE_REPORT_STATUS,
  POLLING_STALE_THRESHOLD_MINUTES,
  POSTURE_CREATED_REASON,
  POSTURE_MIGRATED_REASON,
  POSTURE_STALE_DAYS,
  POST_RETENTION_DAYS,
  PROOF_REVIEW_OVERDUE_BUSINESS_DAYS,
  PayoutStatus,
  ProofStatus,
  QUEST_QUESTION_NO_REPLY_MARKERS,
  QUEST_UPDATED_FIELD_LABELS,
  QuestPresenceEntrySchema,
  QuestPresenceUserSchema,
  QuestTaskCloseReason,
  QuestTaskCreatedVia,
  QuestTaskStatus,
  QuestTaskValueRevisionSource,
  REPLY_NEGLECT_BUSINESS_DAYS,
  RESERVATION_CONFIRM_POLL_MS,
  RESERVATION_CONFIRM_WINDOW_MS,
  RESERVATION_MAX_ATTEMPTS,
  RESERVATION_WATCH_OFFSETS_MS,
  ROSTER_DELIVERY_RULES,
  ROSTER_DRAFT_ARRIVAL_STATUSES,
  ROSTER_DROP_EVENT_ACTIONS,
  ROSTER_NO_REPLY_NUDGE_THRESHOLD,
  ROSTER_STALL_KIND_LABEL,
  ROSTER_STALL_THRESHOLD_DAYS,
  RolePermissions,
  RosterAssigneeChangeCause,
  RosterDeliveryBlock,
  RosterDeliveryCondition,
  RosterDraftEventKind,
  RosterDropEventAction,
  RosterShippingState,
  RosterStallKind,
  SETTLEMENT_NOTIFICATION_HOURS,
  SETTLEMENT_NOTIFICATION_TYPES,
  SPEND_IDLE_GRACE_DAYS_DEFAULT,
  SPEND_RATE_HIGH_FLAG_DEFAULT,
  SPEND_RATE_LOW_FLAG_DEFAULT,
  STIBEE_MAX_RETRIES,
  STIBEE_RETRY_DELAY_MS,
  SYSTEM_ACTOR_USER_ID,
  SYSTEM_ACTOR_USER_SEED,
  SearchKnowledgeQuerySchema,
  TERMINAL_CHECKPOINT_STATUSES,
  TRACKING_IMPORT_APPLIED,
  TRIAGER_ONLY_STATUSES,
  TargetSlotState,
  TeamRolePermissionModifiers,
  TokenType,
  TrackingImportResult,
  UNCLAIMED_CLOSE_REASONS,
  USAGE_DASHBOARD_DEFAULT_DAYS,
  USAGE_DASHBOARD_MAX_DAYS,
  USAGE_DENOMINATOR_NOTE,
  USAGE_TELEMETRY_CAVEATS,
  UpdateKnowledgeSourceSchema,
  VIDEO_POST_PLATFORM_LABEL,
  VIDEO_TRACKING_SUCCEEDED_END_REASONS,
  VIEW_API_PERMISSION,
  VIEW_ELIGIBILITIES,
  VideoPostPlatform,
  VideoPostRole,
  VideoPostStatus,
  WorkLogStatus,
  applyTargetSlotAction,
  approveFeed,
  approveProof,
  assembleHeroPoll,
  assertCanDeleteCheckpoint,
  assertRuleWellFormed,
  assessVideoRetention,
  assignCheckpoint,
  assigneeAfterSend,
  awaitingLeaderReply,
  budgetCarryover,
  budgetPoolKey,
  budgetProjectedRemaining,
  budgetRemaining,
  budgetVariance,
  budgetVarianceRate,
  buildConditionChangeTargets,
  buildSystemActorUpsertArgs,
  buildTemplateUsagePayload,
  calculateClubDuration,
  calculateGaugeProgress,
  calculateLeadTime,
  calculateManagerBonus,
  calculateStalenessPercent,
  campaignRetroDueAt,
  campaignTargetSlotSchema,
  campaignZeroReasonOf,
  canAccessView,
  canAccessViewFull,
  canCommentOnQuestQuestion,
  canConfirmCampaignPerformanceReport,
  canDeleteCheckpoint,
  canEditReplyTemplate,
  canExportRosterShipping,
  canMarkRosterDraftArrival,
  canModifyCheckpoint,
  canNudgeRosterRow,
  canOpenWindowDuringOnboarding,
  canPerform,
  canPromoteToTeamTemplate,
  canReadReplyTemplate,
  canRerequestRosterRevision,
  canSaveCampaignDefault,
  canTransitionCheckpoint,
  canTransitionTo,
  canViewUsageDashboard,
  canWriteQuestQuestion,
  cancelActionFor,
  cancelProof,
  checkClubDurationCap,
  checkExtraPostUrl,
  checkoutQuestTask,
  checkpointTransitionSourcesTo,
  childrenOf,
  classifyArchiveGap,
  classifyArchiveMessage,
  classifyConditionChange,
  classifySpendAnomaly,
  classifyStibeeFailure,
  cloneReplyTemplate,
  clubCodePrefix,
  clubDDay,
  clubDateLabel,
  clubDeadlineLabel,
  compareCheckpointOrder,
  compareReplyUrgency,
  completeCheckpoint,
  completeQuestTask,
  computeCheckpointFillValue,
  computeSettlementWithholding,
  confirmPoll,
  confirmedSubsumeWorks,
  contextNodes,
  countDraftReviewRounds,
  createCheckpoint,
  createDraftContentFromTemplate,
  createMcpTokenSchema,
  createPermission,
  createProduct,
  createProof,
  createQuestQuestion,
  createQuestQuestionComment,
  createQuestTask,
  createQuestTemplate,
  createScenarioProduct,
  createTargetSlotSnapshot,
  createWorkLog,
  creatorMailDraftHistory,
  creatorMailDraftLeaseExpiry,
  creditedActorOf,
  daysSinceInvestment,
  declareProductPosture,
  defaultOutreachTimeZone,
  deleteQuestTask,
  deltaFromCumulative,
  deriveAdvertiserReviewMark,
  deriveAnchorCountsFromOutreachRounds,
  deriveAnchorCountsFromRoster,
  deriveCampaignRetroPermissions,
  deriveCandidateContact,
  deriveEffectiveRosterSnapshot,
  deriveImportRosterStage,
  deriveOutreachFormWatch,
  deriveRosterShippingState,
  deriveRosterStallSignal,
  deriveTargetSlotCounts,
  descendantIds,
  describeAdvertiserReviewRound,
  detectMultiRecord,
  detectSingleRecord,
  detectVideoPostPlatform,
  distributeDividend,
  dividendGrantNote,
  dividendPool,
  effectiveTaskValue,
  elapsedDays,
  ensureSystemActor,
  escapeOutreachHtml,
  exclusionLockAt,
  extractWikiSection,
  findBlockedByAbsorbedPredecessor,
  findPricedQuestsWithoutPromisedDeadline,
  findQuestsMissingBudgetLedger,
  forfeitCheckpoint,
  forfeitCheckpointsOnQuestFail,
  formEntryKeyOf,
  formatAdcodeQuestCreatedBody,
  formatAdcodeRequestedAt,
  formatCheckpointSubmittedBody,
  formatKstMinute,
  formatOpenCallRevokedBody,
  formatOpsSignalCommentAddedBody,
  formatOpsSignalHelpNeededBody,
  formatOpsSignalReportCreatedBody,
  formatOpsSignalStatusChangedBody,
  formatOutreachAmount,
  formatPerformanceReportNotionTable,
  formatQuestApprovedBody,
  formatQuestDeletedBody,
  formatQuestPrerequisitesMetBody,
  formatQuestProofSubmitReminderBody,
  formatQuestProofSubmittedBody,
  formatQuestProposalAdoptedBody,
  formatQuestProposalCreatedBody,
  formatQuestProposalDeclinedBody,
  formatQuestPublishedBody,
  formatQuestQuestionCreatedBody,
  formatQuestRejectedBody,
  formatQuestTaskAttachmentAddedBody,
  formatQuestTaskFeedbackAddedBody,
  formatQuestUpdatedBody,
  formatRosterDropEvent,
  formatScenarioProgressOwnerAssignedBody,
  formatScenarioProgressOwnerRevokedBody,
  formatScheduledLocal,
  formatViews,
  formatWorklogNotSubmittedBody,
  generateClubCode,
  getAccessibleViews,
  getAllAccessibleViews,
  getAppViewLabel,
  getAppViewMeta,
  getCapabilityViews,
  getPermissionsForUser,
  getSettlementSchedule,
  getStageProofGuide,
  guidelineReviewRequirementSchema,
  guidelineReviewRequirementsSchema,
  hangulInitials,
  hasActionMarker,
  hasLostAllTargets,
  hasLostSomeTargets,
  hasNoReplyMarker,
  hasOwnSectionNumbers,
  hasPermission,
  hasPostureMismatch,
  hashToAvatarTint,
  importRosterStageAdvance,
  instantiateQuest,
  isActionFlowNode,
  isAdvertiserReviewPending,
  isAppView,
  isArchiveCopyMissing,
  isAutoFillTask,
  isAutomatedArchiveReply,
  isBudgetLedgerActive,
  isBudgetLedgerClosed,
  isCancelConfirmed,
  isCapabilityView,
  isCeo,
  isChainOpen,
  isCheckpointClosed,
  isCheckpointLockExpired,
  isConditionAgreed,
  isCreatorMailDraftLeaseAlive,
  isCurrentVideoTracking,
  isDefaultExcluded,
  isDefaultExcludedContact,
  isDraftReviewRoundAtRisk,
  isExportUploadConfirmed,
  isForwardRosterStageTransition,
  isInContext,
  isInitialsQuery,
  isInvestmentStale,
  isLinkedChainOpen,
  isManagerBonusEligibleRow,
  isMcpScope,
  isNotificationScope,
  isNotificationType,
  isOnboardingIsolated,
  isOurTurn,
  isOutreachSuppressionReason,
  isProofReviewOverdue,
  isReplyDeadlineAtRisk,
  isReplyNeglected,
  isRosterCreatorOperable,
  isRosterDropEventAction,
  isRoundLocked,
  isSameDayTitleFix,
  isSamePool,
  isSendStarted,
  isSettlementNotificationType,
  isTargetSlotState,
  isUnclaimedCloseReason,
  isUnwrittenOutreachDraft,
  isValidCheckpointType,
  isValidOutreachFormUrl,
  isValidTargetSlotSnapshot,
  isVoteEligible,
  isoWeekKey,
  isoWeekRange,
  judgeTeamRetention,
  listContentPosts,
  managerBonusAllocationOf,
  mapFormResponses,
  maskPayoutValue,
  matchBulkReply,
  mcpScopeSchema,
  memoryImageTint,
  messagesToGraph,
  missingRosterDeliveryConditions,
  myShareReasonOf,
  needsActualValue,
  nextContractVideoNo,
  nextReservationConfirmStep,
  normalizeShippingCarrier,
  normalizeSuppressionEmail,
  normalizeTrackingNumber,
  notSettledReasonOf,
  oauthConsentApproveSchema,
  oauthConsentDenySchema,
  orderRosterForExport,
  outreachFormRespondUrl,
  outreachHandleEntryKeys,
  outreachProductName,
  parseFromAddress,
  parseOutreachFormUrl,
  parsePayoutInput,
  parsePriorityBasis,
  payPeriodElapsedDays,
  pendingSubsumeWorks,
  performanceReportPrintHeader,
  permissionsFromScopes,
  planAdditionalContractVideo,
  planRoundExclusions,
  planTrackingImport,
  priorContribution,
  projectedSpendRate,
  qualifiesForFlexWeeklyWork,
  readCreatorMailDraftTakeovers,
  readPollingSilence,
  readPostAccess,
  readTrackingSheet,
  recalculateLockStates,
  recommendedTeamBudget,
  rejectProof,
  releaseCheckpoint,
  releaseCheckpointsOnDrop,
  remainingAfterTask,
  renderOutreachDraftHtml,
  replaceWikiSection,
  reservationGuardAtLock,
  resolveAppliedConditions,
  resolveFormQuestionIds,
  resolveReplyDeadline,
  resolveRosterDraftReceivedAt,
  resolveScheduledInstant,
  resubmitProof,
  retentionBusinessDate,
  retentionStartOf,
  retentionWindow,
  reviewQuestQuestionReplies,
  revisedAfterLogDay,
  rosterDeliveryBlock,
  rosterFormEventAt,
  rosterPayoutWriteSchema,
  scoreOf,
  seedEventTypeForRosterStage,
  selectConversationMessages,
  serializeContext,
  shareUnpaidReasonOf,
  spendRate,
  splitWikiSections,
  statusLabel,
  stibeeReserveTime,
  stibeeRetryDecision,
  stripMarkers,
  strongerSuppression,
  submitProof,
  submitQuestProof,
  submitWorkLog,
  summarizeCampaignPerformance,
  summarizeConditionChange,
  summarizeCreatorPosts,
  summarizeDomesticQueue,
  summarizeRosterDraftEvents,
  summarizeRosterNudges,
  suppressionOfPerson,
  targetSlotAssignmentSchema,
  targetSlotDeliverySchema,
  targetSlotSnapshotSchema,
  teamBudgetTypeCoef,
  titleSimilarity,
  unfilledOutreachVariables,
  ungrantableScopes,
  updateCheckpoint,
  updateProduct,
  updateProofDraft,
  updateQuestTask,
  updateQuestTemplate,
  updateScenarioProduct,
  updateWorkLog,
  usageDashboardQuerySchema,
  validateCampaignRetroDeadline,
  videoRemark
} from "./chunk-ZCQVU2O3.mjs";
import {
  ALLOWED_BUCKETS,
  ALLOWED_MIME_TYPES,
  APPROVAL_HISTORY_AUDIT_TARGETS,
  AUDIT_LOG_ACCESS_ACTION,
  AUDIT_LOG_EXPORT_MAX_ROWS,
  AUDIT_LOG_PII_RETENTION_DAYS,
  AUDIT_LOG_ROW_RETENTION_DAYS,
  AUDIT_LOG_ROW_RETENTION_EXEMPTIONS,
  AUDIT_LOG_SYSTEM_ACTION,
  AUDIT_PATH_SCOPED_SENSITIVE_KEYS,
  BULK_ARCHIVE_MAX_IDS,
  BULK_VOID_MAX,
  CAMPAIGN_ADCODE_DRY_RUN_MAX_ROWS,
  CAMPAIGN_ADCODE_DRY_RUN_PREVIEW_LIMIT,
  CAMPAIGN_ROSTER_IMPORT_MAX_ROWS,
  CAMPAIGN_ROSTER_SENSITIVE_KEYS,
  CANDIDATE_QUERY_STATES,
  CHANNEL_DESCRIPTION_MAX_LENGTH,
  CHECKIN_INTERVAL_GRADE_KEYS,
  CHECKIN_INTERVAL_MIN_SAMPLE,
  CHECKPOINT_UNIT_MAX,
  CLIENT_TELEMETRY_EVENT_NAMES,
  CREATOR_COLLECTION_STATES,
  CREATOR_LIST_CHANNELS,
  CREATOR_LIST_CONTACT_BATCH,
  CREATOR_LIST_CONTACT_LOG_NOTICE,
  CREATOR_LIST_DOWNLOAD_ROUTE,
  CREATOR_LIST_FILE_LIMIT,
  CREATOR_LIST_FILE_LIMIT_MAX,
  CREATOR_LIST_REDOWNLOAD_DAYS,
  CREATOR_LIST_RETENTION_DAYS,
  CREATOR_MAIL_CONNECTION_STATUSES,
  CREATOR_MAIL_CONNECT_FAILURES,
  CREATOR_PII_FIELD_KEYS,
  CREATOR_PII_FIELD_MAX_LENGTH,
  CREATOR_PII_PURGE_BLOCKED,
  CREATOR_PII_PURGE_CAUSES,
  CREATOR_PII_RETENTION_MONTHS,
  CREATOR_RELATION_HANDLE_RELATIONS_OVERFLOW,
  CREATOR_RELATION_LIST_SORTS,
  CREATOR_RELATION_LIST_TAKE,
  CREATOR_RELATION_SEEDING_TEAM_IDS_KEY,
  CREATOR_RELATION_SEEDING_TEAM_INVALID,
  CREATOR_RELATION_SENSITIVE_KEYS,
  CREATOR_RELATION_VIEWS,
  CREATOR_SEARCH_QUERY_MAX,
  CREATOR_SEARCH_QUERY_MIN,
  CREATOR_VIEW_METRICS_IDS_MAX,
  CampaignAdcodeDryRunConflictCode,
  CampaignAdcodeDryRunOutcome,
  CampaignAdcodeDryRunUnresolvedCode,
  CampaignAdcodeImportOutcome,
  CampaignRosterImportOutcome,
  CampaignRosterWarningCode,
  CampaignVideoReviewFileKind,
  CampaignVideoReviewFileState,
  CampaignVideoReviewSourceType,
  EXPIRY_CLOSE_DISPOSITIONS,
  EXPIRY_CLOSE_EVENT_PREFIX,
  LEADERBOARD_PERIODS,
  MAX_FILE_SIZE,
  MAX_VIDEO_REVIEW_FILE_BYTES,
  MONTHLY_RETRO_METRIC_KEYS,
  MONTHLY_RETRO_STATUSES,
  MONTHLY_RETRO_UNDATED,
  NOTIFICATION_OPT_IN_TOPICS,
  OUTREACH_CTA_ALIGNS,
  OUTREACH_CTA_PRESETS,
  OUTREACH_CTA_WIDTHS,
  OUTREACH_HANDLE_FIELD_KEYS,
  OUTREACH_OUTLIER_GROUP_CODES,
  OUTREACH_OUTLIER_GROUP_RULES,
  OUTREACH_OUTLIER_OTHER_TEAM_DAYS,
  OUTREACH_OUTLIER_OTHER_TEAM_EVENTS,
  OUTREACH_OUTLIER_PAGE_MAX,
  OUTREACH_OUTLIER_PRECEDENCE,
  OUTREACH_OUTLIER_PREVIEW_DEFAULT,
  OUTREACH_PICK_COUNT_MAX,
  OUTREACH_PRESENCE_HEARTBEAT_MS,
  OUTREACH_PRESENCE_LEASE_MS,
  OUTREACH_REINCLUDE_REASONS,
  OUTREACH_RETENTION_POLICY,
  OUTREACH_ROUND_MAX_HANDLES,
  OUTREACH_SELECTION_MAX_IDS,
  OUTREACH_SELECTION_MODES,
  PAGE_VIEW_RETENTION_DAYS,
  POINT_HISTORY_EXPORT_MAX_ROWS,
  POINT_TEAM_ATTRIBUTION_IS_POINT_IN_TIME,
  POINT_TEAM_ATTRIBUTION_LABELS,
  POINT_TEAM_UNATTRIBUTED,
  POINT_TEAM_UNATTRIBUTED_LABEL,
  PRICING_GROUND_PREFIX,
  PRICING_REASON_CODES,
  PROOF_FAILURE_STAGES,
  PROOF_SUBMISSION_PATHS,
  QUEST_TASK_TITLE_MAX,
  REACH_CHANNELS,
  REACH_CHANNEL_LABELS,
  REALTIME_TOKEN_REFRESH_LEAD_SECONDS,
  REALTIME_TOKEN_TTL_SECONDS,
  RELATION_CONTACT_CHANNELS,
  RELATION_CONTACT_CHANNEL_LABELS,
  RESERVATION_RANGE_MAX_DAYS,
  REVIEWED_HISTORY_MAX_DAYS,
  ROSTER_CHANGE_KINDS,
  ROSTER_LOCKABLE_FIELDS,
  ROSTER_LOCK_ACTIONS,
  ROSTER_MANUAL_COMMUNICATION_CHANNELS,
  ROSTER_MANUAL_COMMUNICATION_EVENT_TYPES,
  ROSTER_MANUAL_COMMUNICATION_TARGET_ROLES,
  ROSTER_SHIPPING_EXPORT_FIELDS,
  SERVER_TELEMETRY_EVENT_NAMES,
  SETTLEMENT_MARKABLE_STATUSES,
  SETTLEMENT_REQUEST_MAX_ENTRIES,
  SHORT_LINK_ALIAS_PATTERN,
  SHORT_LINK_PREVIEW_BOT_PATTERN,
  SHORT_LINK_RESERVED_ALIASES,
  SUPPORTED_VIDEO_MIME_TYPES,
  ScenarioReferenceSchema,
  TAX_INCOME_BULK_MAX,
  TEAM_SCHEDULE_MAX_DAYS,
  TELEMETRY_EVENT_NAMES,
  TELEMETRY_EVENT_RETENTION_DAYS,
  VIDEO_TRACKING_ERROR_MESSAGES,
  VIDEO_TRACKING_INBOX_REASONS,
  VIEW_METRICS_COVERAGE,
  VIEW_METRICS_DISPLAY_STATES,
  VIEW_METRICS_FRESHNESS,
  VIEW_METRICS_LAST_COLLECTION,
  VIEW_METRICS_REFRESH_STATES,
  VIEW_METRICS_SAMPLE_STATUS,
  VIEW_METRICS_SNAPSHOT_CAPTURED_ON,
  VIEW_METRICS_SNAPSHOT_OUTCOMES,
  VIEW_METRICS_UNAVAILABLE_REASONS,
  WIKI_BODY_MAX,
  WIKI_COMMENT_MAX,
  WIKI_DISCUSSION_TITLE_MAX,
  WIKI_IMAGE_BUCKET,
  WIKI_IMAGE_MIME_TYPES,
  WIKI_TITLE_MAX,
  acceptQuestSchema,
  acceptanceScenarioRefSchema,
  addAttachmentSchema,
  addMemberSchema,
  addQuestDependencySchema,
  adjustBalanceSchema,
  adjustPointsSchema,
  adminCancelLeaveSchema,
  advertiserBrandBodySchema,
  advertiserContactSchema,
  approveCheckpointSchema,
  approveCorrectionSchema,
  approveFeedCapExceededSchema,
  approveFeedResponseSchema,
  approvePieceworkSchema,
  approveProofSchema,
  approveQuestSchema,
  assignCampaignTargetSlotSchema,
  assignCheckpointSchema,
  assignCreatorRelationOwnerSchema,
  autoSubmitCheckpointProofSchema,
  autoSubmitQuestProofSchema,
  batchRegisterSchema,
  batchRegisterUserSchema,
  batchReviewOffDaySchema,
  blockCreatorRelationSchema,
  bulkArchiveQuestsResponseSchema,
  bulkArchiveQuestsSchema,
  bulkCreateCampaignRosterVideoRightSchema,
  bulkMarkCampaignSettlementStatusSchema,
  bulkVoidPayoutResponseSchema,
  bulkVoidPayoutSchema,
  bulkVoidPayoutSkippedSchema,
  campaignAdcodeDryRunRowSchema,
  campaignAdcodeDryRunSchema,
  campaignAdcodeImportSchema,
  campaignRetroListQuerySchema,
  campaignRosterImportRowSchema,
  campaignRosterImportSchema,
  campaignRosterProfileLinkResolveSchema,
  campaignTimelineEntrySchema,
  campaignTimelineSaveSchema,
  campaignVideoTrackingMetricsSchema,
  cancelCampaignTargetSlotSchema,
  cancelCampaignVideoReviewRevisionSchema,
  challengeCandidateSchema,
  changeAdvertiserReviewModeSchema,
  changeCreatorRelationStateSchema,
  clientTelemetryEventNameSchema,
  clockInSchema,
  clockOutSchema,
  closeDaySchema,
  clubTransferLeadershipSchema,
  completeQuestTaskSchema,
  confirmCreatorResolutionSchema,
  confirmPerformanceReportSchema,
  confirmPollSchema,
  convertBugReportToQuestSchema,
  createAdcodeCommentSchema,
  createAdvertiserSchema,
  createAgentSchema,
  createApprovedOriginalUploadSchema,
  createAttendanceSchema,
  createBugReportSchema,
  createCampaignRetroObservationSchema,
  createCampaignRosterDropRestoreSchema,
  createCampaignRosterDropSchema,
  createCampaignRosterEntrySchema,
  createCampaignRosterExtraPostSchema,
  createCampaignRosterManualCommunicationSchema,
  createCampaignRosterPriceRevisionSchema,
  createCampaignRosterScheduleRevisionSchema,
  createCampaignRosterSnapshotRevisionSchema,
  createCampaignRosterUploadTakedownSchema,
  createCampaignRosterVideoRightSchema,
  createCampaignSettlementRequestSchema,
  createCampaignVideoReviewRevisionSchema,
  createCampaignVideoReviewUploadSessionSchema,
  createChannelGroupSchema,
  createChannelSchema,
  createCheckpointSchema,
  createClubSchema,
  createCompensationSchema,
  createConditionAgreementSchema,
  createConversationSchema,
  createCorrectionSchema,
  createCreatorNotepadEntrySchema,
  createCreatorRelationNoteSchema,
  createCreatorRelationSchema,
  createDayScheduleSchema,
  createDepartmentSchema,
  createDropSignalSchema,
  createEventSchema,
  createFeedSchema,
  createHolidaySchema,
  createLeaveRequestSchema,
  createOperationalIssueReportSchema,
  createOperationalReportCommentSchema,
  createPageViewSchema,
  createPieceworkActivitySchema,
  createPollSchema,
  createProductSchema,
  createProofSchema,
  createQuestAttachmentSchema,
  createQuestBaseSchema,
  createQuestProposalSchema,
  createQuestQuestionCommentSchema,
  createQuestQuestionSchema,
  createQuestSchema,
  createQuestTaskFeedbackCommentSchema,
  createQuestTaskFeedbackSchema,
  createQuestTaskSchema,
  createQuestTemplateSchema,
  createReplyTemplateSchema,
  createReservationSchema,
  createRoomSchema,
  createScenarioProductSchema,
  createScenarioSchema,
  createScenarioTemplateSchema,
  createSegmentCorrectionSchema,
  createSelectionGuidelineSchema,
  createShortLinkSchema,
  createSignedUploadUrlSchema,
  createTaskForceSchema,
  createTelemetryEventSchema,
  createTelemetryObservationQuestionSchema,
  createTelemetryObservationReviewSchema,
  createTemplateCheckpointSchema,
  createTimelineEventSchema,
  createWikiAreaSchema,
  createWikiDiscussionCommentSchema,
  createWikiDiscussionSchema,
  createWikiDocumentSchema,
  createWikiImageUploadSchema,
  createWorkLogSchema,
  creatorCampaignPriceSchema,
  creatorListBuildSchema,
  creatorListDownloadPath,
  creatorListQueryRequestSchema,
  creatorMailThreadRevisionSchema,
  creatorNotepadEntryResponseSchema,
  creatorRelationCardSchema,
  creatorRelationCardSectionsSchema,
  creatorRelationHistoryCursorSchema,
  creatorRelationHistoryItemSchema,
  creatorRelationHistoryPageSchema,
  creatorRelationIntimacyMeasureSchema,
  creatorRelationListCursorSchema,
  creatorRelationListItemSchema,
  creatorRelationListQuerySchema,
  creatorRelationListResponseSchema,
  creatorRelationListViewerSchema,
  creatorRelationOtherTeamContactSchema,
  creatorRelationOtherTeamContactsQuerySchema,
  creatorRelationOtherTeamContactsResponseSchema,
  creatorRelationPersonSchema,
  creatorRelationPiiSchema,
  creatorRelationQueueResponseSchema,
  creatorRelationRefSchema,
  creatorRelationRegionSchema,
  creatorRelationRegionsResponseSchema,
  creatorRelationSummaryQuerySchema,
  creatorRelationSummaryResponseSchema,
  creatorRelationTimelineQuerySchema,
  creatorViewMetricsQuerySchema,
  dayScheduleContentSchema,
  dayScheduleDateSchema,
  dayScheduleMonthSchema,
  dayScheduleSharedTeamSchema,
  decidePieceworkActivitySchema,
  deriveViewMetricsDisplayState,
  distributionKindSchema,
  dokkaebiSignalSchema,
  editAttendanceSchema,
  editBugReportSchema,
  editMessageSchema,
  expiryCloseQuestSchema,
  feedAttachmentInputSchema,
  findAggregateAttendancesSchema,
  formatPricingGround,
  generateHolidaySchedulesSchema,
  getWikiDocumentQuerySchema,
  grantLeaveSchema,
  grantPointsSchema,
  initializeCampaignTargetSlotsSchema,
  instantiateQuestSchema,
  instantiateTemplateSchema,
  inviteMemberSchema,
  isLeaderboardPeriod,
  isNotificationOptInTopic,
  isShortLinkTargetAllowed,
  isViewMetricsSampleInsufficient,
  isWikiImageFile,
  issueCampaignAdcodeSchema,
  judgeCampaignVideoReviewRevisionSchema,
  kickMemberSchema,
  listQuestProposalsQuerySchema,
  listReservationsQuerySchema,
  listReservationsRangeQuerySchema,
  listShortLinksSchema,
  listWikiDiscussionsQuerySchema,
  listWikiDocumentsQuerySchema,
  managerBonusListQuerySchema,
  managerBonusRowCountsSchema,
  markCampaignSettlementStatusSchema,
  markPaidSchema,
  markSettlementDocumentsSchema,
  mergeAdvertiserSchema,
  mergeFromDraftSchema,
  moveChannelToGroupSchema,
  openAdvertiserReviewRoundSchema,
  outreachBlockCreatorRelationSchema,
  outreachBulkReserveSchema,
  outreachBulkSendSchema,
  outreachDraftContentSchema,
  outreachDraftCtaSchema,
  outreachOutlierRowsRequestSchema,
  outreachOutlierSummaryRequestSchema,
  outreachPresenceLeaseExpiry,
  outreachTestSendSchema,
  outreachUnblockCreatorRelationSchema,
  parseSeedingTeamIds,
  parseTiktokVideoLink,
  passkeyLoginOptionsSchema,
  passkeyLoginVerifySchema,
  payoutVoidReasonSchema,
  periodSummaryQuerySchema,
  pricingGroundSchema,
  productPostureSchema,
  productSubsumeWorkInputSchema,
  productTargetInputSchema,
  proofAttachmentSchema,
  proofFailureStageSchema,
  proofSubmissionPathSchema,
  queryAuditLogsSchema,
  queryPageViewStatsSchema,
  queryProofSubmissionStatsSchema,
  queryQuestCreationStatsSchema,
  queryTelemetryEventStatsSchema,
  queryTelemetryObservationQuestionsSchema,
  questDependencyHistoryQuerySchema,
  questDependencyReasonSchema,
  questDistributionKindSchema,
  questTaskTitleError,
  realtimeTokenResponseSchema,
  reassignCampaignRosterAssigneeSchema,
  reassignSegmentSchema,
  recentWikiChangesQuerySchema,
  recordAdvertiserReviewVerdictsSchema,
  recordCampaignReportSchema,
  recordOffRosterContactSchema,
  rejectAdcodeRequestSchema,
  rejectCheckpointSchema,
  rejectProofSchema,
  rejectQuestSchema,
  relinkRosterCreatorSchema,
  renamePasskeySchema,
  reorderCheckpointsSchema,
  reorderQuestsSchema,
  representativeImageSchema,
  requestAdcodeSchema,
  requestProofResubmitSchema,
  requestRosterCreatorCollectionSchema,
  requestVaSchema,
  resolveMissedClockInSchema,
  resolveMissedClockOutSchema,
  resolveQuestProposalSchema,
  resolveStaleTaskSchema,
  resubmitCorrectionSchema,
  revertWikiDocumentSchema,
  reviewCorrectionSchema,
  reviewLeaveRequestSchema,
  reviewOffDaySchema,
  revokeWorldQuestSchema,
  rosterManualCommunicationChannelSchema,
  rosterManualCommunicationEventTypeSchema,
  rosterManualCommunicationStatsQuerySchema,
  rosterManualCommunicationTargetRoleSchema,
  saveAsTemplateSchema,
  saveCreatorMailDraftSchema,
  saveOutreachDraftSchema,
  saveOutreachSelectionSchema,
  scenarioAcceptancePanelSchema,
  scenarioAcceptanceRowSchema,
  scenarioTemplateQuestItemSchema,
  searchCreatorProjectionsSchema,
  searchWikiQuerySchema,
  segmentEditItemSchema,
  selectionGuidelineQuerySchema,
  sendAssistantMessageSchema,
  sendCreatorMailSchema,
  sendMessageAttachmentSchema,
  sendMessageSchema,
  setChannelNotifyLevelSchema,
  settlementQueueQuerySchema,
  shortLinkSchemas,
  shortLinkSubjectKeySchema,
  startCreatorMailConnectionSchema,
  stopRuleSchema,
  submitPieceworkSchema,
  submitProofSchema,
  summarizePointTeamAttribution,
  syncHolidaysSchema,
  takeOverCreatorMailDraftSchema,
  targetSlotCandidatesQuerySchema,
  targetSlotChangedEventSchema,
  taxIncomeBulkQuerySchema,
  taxIncomeSummaryQuerySchema,
  teamOpsAttendanceBulkEntrySchema,
  teamOpsAttendanceBulkQuerySchema,
  teamOpsAttendanceBulkResponseSchema,
  teamOpsAttendanceSourceSchema,
  teamOpsAttendanceStatusSchema,
  teamOpsReadScopeSchema,
  teamOpsRosterFiltersSchema,
  teamOpsRosterMembershipSchema,
  teamOpsRosterQuerySchema,
  teamOpsRosterResponseSchema,
  teamOpsRosterTeamSchema,
  teamOpsRosterVisibilitySchema,
  teamOpsWorklogDaySchema,
  teamOpsWorklogMonitoringEntrySchema,
  teamOpsWorklogMonitoringQuerySchema,
  teamOpsWorklogMonitoringResponseSchema,
  teamOpsWorklogTaskSchema,
  teamScheduleQuerySchema,
  telemetryEventNameSchema,
  telemetryObservationMetricSchema,
  telemetryObservationOutcomeSchema,
  telemetryObservationQuerySchema,
  telemetryObservationQuestionDetailSchema,
  telemetryObservationQuestionSchema,
  telemetryObservationReviewSchema,
  telemetryObservationSnapshotSchema,
  telemetryObservationStatusSchema,
  telemetryPayloadSchema,
  toggleReactionSchema,
  trackingImportRequestSchema,
  transferLeadershipSchema,
  transferOwnershipSchema,
  unblockCreatorRelationSchema,
  updateAdcodeMetricsSchema,
  updateAdvertiserContactSchema,
  updateAdvertiserSchema,
  updateAgentSchema,
  updateBoostingStageSchema,
  updateBugReportSchema,
  updateCampaignRetroDeadlineSchema,
  updateCampaignRosterEntrySchema,
  updateCampaignSlotConditionsSchema,
  updateChannelGroupSchema,
  updateChannelSchema,
  updateCheckpointSchema,
  updateConversationEntitySchema,
  updateConversationSchema,
  updateDayScheduleSchema,
  updateDropSignalStatusSchema,
  updateEmailSchema,
  updateExcludeFromAttendanceSchema,
  updateFeedSchema,
  updateHireDateSchema,
  updateHolidaySchema,
  updateIssueReportStatusSchema,
  updateLevelSchema,
  updateOnboardingGuideSchema,
  updatePieceworkActivitySchema,
  updatePointsSchema,
  updateProductSchema,
  updateProofDraftSchema,
  updateQuestSchema,
  updateQuestTaskSchema,
  updateQuestTemplateSchema,
  updateReplyTemplateSchema,
  updateReservationAttendeesSchema,
  updateReservationSchema,
  updateRolesSchema,
  updateRoomSchema,
  updateScenarioOutreachFormSchema,
  updateScenarioProductSchema,
  updateScenarioSchema,
  updateScenarioTemplateSchema,
  updateSeedingTeamIdsSchema,
  updateSettingsSchema,
  updateShortLinkSchema,
  updateTargetSlotOverridesSchema,
  updateTargetSlotParticipantSchema,
  updateTeamCapabilitiesSchema,
  updateTeamSchema,
  updateTeamSettingsSchema,
  updateTimelineEventSchema,
  updateWikiAreaSchema,
  updateWikiDocumentSchema,
  updateWikiDocumentToolSchema,
  updateWikiSectionSchema,
  updateWorkLogSchema,
  updateWorkTypeSchema,
  upsertCreatorRelationPiiSchema,
  upsertWorkScheduleSchema,
  validateQuestCreationIds,
  verifyPasskeyRegistrationSchema,
  videoTrackingConfirmReplacementRequestSchema,
  videoTrackingConfirmRequestSchema,
  videoTrackingControlRequestSchema,
  videoTrackingCorrectLinkRequestSchema,
  videoTrackingErrorMessage,
  videoTrackingRegisterRequestSchema,
  videoVisibilityReviewSchema,
  voidPayoutSchema,
  voteSchema,
  weeklySummaryQuerySchema,
  wikiAreaKeySchema,
  wikiByTitleQuerySchema,
  wikiDocumentMetricsSchema,
  wikiImageExtension,
  wikiImageFileFromSrc,
  wikiImageSrc,
  wikiMetricsSchema,
  wikiRevisionGuardSchema,
  withdrawQuestSchema,
  worklogNudgeSchema
} from "./chunk-APNBHZQP.mjs";
import {
  ADCODE_REQUEST_COMMENT_MAX_LENGTH,
  ADJUST_REASON_CATEGORIES,
  ADJUST_REASON_CATEGORY_LABELS,
  ADVERTISER_REVIEW_MODES,
  ADVERTISER_REVIEW_MODE_LABEL,
  ADVERTISER_REVIEW_VERDICTS,
  ADVERTISER_REVIEW_VERDICT_LABEL,
  AGENT_ERROR_CODES,
  ASSISTANT_ERROR_CODES,
  ATTENDANCE_ERROR_CODES,
  AUTH_ERROR_CODES,
  AdcodeLabelKey,
  AdvertiserReviewMode,
  AdvertiserReviewVerdict,
  AgentConnectionType,
  AgentMessageType,
  AgentStatus,
  ApprovedOriginalFileOrigin,
  ApprovedOriginalReceivedVia,
  ApprovedOriginalSource,
  ApprovedOriginalState,
  AttendanceStatus,
  BAND_MEDIAN,
  BLOCK_REASON_KINDS,
  BOOSTING_RESUME_EDGES,
  BOOSTING_STAGE_ORDER,
  BUDGET_LEDGER_ERROR_CODES,
  BoostingFlagWarning,
  BoostingStage,
  Brand,
  CAMPAIGN_AD_CODE_PATTERN,
  CAMPAIGN_DIFFICULTY_CONDITIONS,
  CAMPAIGN_SLOT_PRICE,
  CAMPAIGN_TIMELINE_LABEL_MAX,
  CAMPAIGN_TIMELINE_MAX_ENTRIES,
  CAMPAIGN_TIMELINE_MILESTONE_LABEL,
  CEO_POLICY_DEFAULTS,
  CEO_POLICY_EFFECT_NOTES,
  CEO_POLICY_KEYS,
  CEO_POLICY_LABELS,
  CHANNEL_NOTIFY_LEVELS,
  CHAT_ERROR_CODES,
  CHECKPOINT_ERROR_CODES,
  CHECKPOINT_ORDER_MIN,
  CLIENT_PLATFORMS,
  CLUB_ERROR_CODES,
  COMMON_ERROR_CODES,
  CONTRACT_PARTY_KINDS,
  CREATOR_EMAIL_MAX_LENGTH,
  CREATOR_PIPELINE_MAX_LAG_MS,
  CREATOR_PRICE_PLATFORMS,
  CREATOR_RELATION_INVALID_TRANSITION,
  CREATOR_RELATION_SOURCE_SYSTEM,
  CREATOR_RESEND_CLOSED_MESSAGE,
  CREATOR_UNKNOWN_TO_SOURCE,
  CREVASSE_EMAIL_DOMAIN,
  CROP_ASPECT_PRESETS,
  CYCLE_KEY_NONE,
  CampaignDifficulty,
  CampaignTimelineMilestone,
  CheckpointOrderSchema,
  CheckpointRejectReasonKind,
  ClubMetadataSchema,
  CompensationType,
  CorrectionStatus,
  CreatorPricePlatform,
  CreatorVisibilityTier,
  CrevasseEmailSchema,
  DEEP_LINK_VIEW_PARAM,
  DEFAULT_ADVERTISER_REVIEW_MODE,
  DEFAULT_FEATURE_FLAGS,
  DEFAULT_OUTREACH_DATE_FORMAT,
  DEFAULT_PAGE_LIMIT,
  DEFAULT_PAY_DAY,
  DEFAULT_POINT_TO_KRW_RATE,
  DEFAULT_ROSTER_STATUS,
  DEPARTED_USER_STATUSES,
  DEV_VISIBLE_HIDDEN_FLAGS,
  DISTRIBUTION_KINDS,
  DOKKAEBI_SYSTEM_USER_ID,
  DOMESTIC_TARGET_COUNTRIES,
  EMAIL_LABEL_KEYS,
  EmailSchema,
  FREE_CROP_MAX_RATIO,
  FREE_CROP_MIN_RATIO,
  FinanceLedgerNavigationSchema,
  HolidayPaidType,
  IDLE_WARN_DAYS,
  INACTIVE_ATTENDANCE_STATUSES,
  INTERN_CONVERSION_REVIEW_MONTHS,
  ISO8601_PATTERN,
  ISO_COUNTRIES,
  ISO_COUNTRY_BY_CODE,
  Iso8601Schema,
  IsoCountryCodeArraySchema,
  IsoCountryCodeSchema,
  LEAVE_ERROR_CODES,
  LEAVE_TYPE_LABELS,
  LEGAL_NAME_MAX_LENGTH,
  LEGAL_NAME_MIN_LENGTH,
  LEVEL_LABELS,
  LeaveApprovalStatus,
  LeaveApprovalType,
  LeaveProofStatus,
  LeaveStatus,
  LeaveType,
  LegalNameSchema,
  LoginTicketSchema,
  MAX_CORRECTION_SPAN_MS,
  MAX_QUESTS_PER_SCENARIO,
  MESSAGE_CONTENT_MAX_LENGTH,
  MIN_WORK_SEGMENT_BEFORE_BREAK_MS,
  MappingWarningCode,
  MessageContentSchema,
  NOTIFICATION_FEATURE_MAP,
  NavigationContextSchema,
  ONBOARDING_QUEST_ORIGIN,
  OPERATIONAL_REASONS_BY_AREA,
  OUTREACH_DATE_FORMATS,
  OUTREACH_METRIC_KEYS,
  OWNER_CHANGE_CAUSES,
  OffDayApprovalStatus,
  PASSWORD_MIN_LENGTH,
  PASSWORD_PATTERN,
  PAYOUT_LABEL_KEYS,
  PII_LABEL_KEYS,
  POINTS_MIN,
  POINT_ERROR_CODES,
  PROOF_DESCRIPTION_MAX_LENGTH,
  PROOF_ERROR_CODES,
  PROOF_REMINDER_SUBMITTED_STATUSES,
  PROPOSAL_ERROR_CODES,
  PUNCH_QUEUE,
  PasswordSchema,
  PieceworkActivityStatus,
  PieceworkAudienceScope,
  PieceworkCycle,
  PieceworkSubmissionStatus,
  PointHistoryType,
  PointsSchema,
  QUEST_DIFFICULTY_CRITERIA_TEXT,
  QUEST_DIFFICULTY_GUIDE,
  QUEST_DIFFICULTY_LEVELS,
  QUEST_ERROR_CODES,
  QUEST_PROPOSAL_DESCRIPTION_MAX_LENGTH,
  QUEST_PROPOSAL_TITLE_MAX_LENGTH,
  QUEST_STATES,
  QUEST_TASK_ERROR_CODES,
  QUEST_TEMPLATE_ERROR_CODES,
  QUEST_TRANSITIONS,
  QUEST_WEIGHT_ALPHA_DEFAULT,
  QUEST_WEIGHT_FORMULA_VERSION,
  QuestAcceptanceStatus,
  QuestApprovalStatus,
  QuestDifficulty,
  QuestProductAttachmentViolation,
  QuestProposalDescriptionSchema,
  QuestProposalStatus,
  QuestProposalTitleSchema,
  QuestScope,
  QuestStatus,
  QuestTargetType,
  RANK_ERROR_CODES,
  REGULAR_PARAMS,
  RELATION_HISTORY_ORIGINS,
  RELATION_HISTORY_TYPES,
  RELATION_STATES,
  REPLY_TEMPLATE_KINDS,
  REPLY_TEMPLATE_LAYERS,
  REPLY_TEMPLATE_STAGES,
  REPLY_TEMPLATE_VARIABLE_KEYS,
  RESUME_POINT_MAX_LENGTH,
  REVERSIBLE_POINT_HISTORY_TYPES,
  REWARD_POINTS_MIN,
  RE_RECRUIT_REASON_KINDS,
  ROSTER_CONTENT_REVIEWS,
  ROSTER_CONTENT_REVIEW_DISPLAY_LABEL,
  ROSTER_DROP_KINDS,
  ROSTER_DROP_KIND_LABEL,
  ROSTER_LABEL_ALIASES,
  ROSTER_MANUAL_DROP_KINDS,
  ROSTER_PRICE_PROPOSERS,
  ROSTER_SCHEDULE_KINDS,
  ROSTER_STATUSES,
  ROSTER_TAKEDOWN_REQUESTERS,
  ROSTER_WRITABLE_STATUSES,
  RelationStateChangeError,
  RewardPointsSchema,
  RosterBallHolder,
  RosterContentReview,
  RosterContentReviewDisplay,
  RosterDropKind,
  RosterLabelKey,
  RosterPhase,
  RosterPriceProposer,
  RosterScheduleKind,
  RosterStatus,
  RosterTakedownRequester,
  SCENARIO_CREATOR_COUNT_MAX,
  SCENARIO_CREATOR_COUNT_MIN,
  SCENARIO_ERROR_CODES,
  SCENARIO_OPERATIONAL_ISSUE_REPORT_COMMENT_MAX_LENGTH,
  SCENARIO_OPERATIONAL_SIGNAL_GAP_ALIGNED_HOURS,
  SCENARIO_OPERATIONAL_SIGNAL_REPORTS_LIMIT,
  SCENARIO_PROGRESS_METRIC_KEYS,
  SCENARIO_PROGRESS_METRIC_LABEL,
  SCENARIO_SEED_QUEST_ORIGIN,
  SCENARIO_TARGET_TOTAL_VIEWS_MAX,
  SCENARIO_TEMPLATE_CREATOR_COUNT_MAX,
  SCENARIO_TEMPLATE_CREATOR_COUNT_MIN,
  SCENARIO_TEMPLATE_DURATION_DAYS_MIN,
  SCENARIO_TEMPLATE_TARGET_REGION_MAX,
  SETTINGS_ERROR_CODES,
  SETTLEMENT_AMOUNT_PATTERN,
  SETTLEMENT_APPROVAL_CLEARANCE_TRANSITION,
  SETTLEMENT_APPROVAL_THRESHOLD_CURRENCY,
  SETTLEMENT_APPROVAL_THRESHOLD_USD,
  SETTLEMENT_CURRENCY_PATTERN,
  SETTLEMENT_DOMESTIC_CURRENCY,
  SETTLEMENT_KINDS,
  SETTLEMENT_KIND_ACCOUNTING_DEFAULTS,
  SETTLEMENT_REASON_REQUIRED_STATUSES,
  SETTLEMENT_REQUESTABLE_KINDS,
  SETTLEMENT_STATUS_TRANSITIONS,
  SYSTEM_TIMELINE_EVENT_TYPES,
  ScenarioCampaignType,
  ScenarioContentDeliveryIssueReason,
  ScenarioContractTargetRevisionStatus,
  ScenarioDropSignalStatus,
  ScenarioOperationalHealthLabel,
  ScenarioOperationalIssueArea,
  ScenarioOperationalIssueReportStatus,
  ScenarioOperationalSignalGapDirection,
  ScenarioProgressBlockerCode,
  ScenarioProgressCompletionState,
  ScenarioProgressMetricKey,
  ScenarioRecruitingIssueReason,
  ScenarioReviewMode,
  ScenarioStatus,
  ScheduleType,
  SegmentSourceType,
  SegmentType,
  SettlementApprovalUndeterminedReason,
  SettlementApprovalVerdict,
  SettlementCostBearer,
  SettlementKind,
  SettlementPayoutForm,
  SettlementPayoutMethod,
  SettlementStatus,
  StopRuleDirection,
  StopRuleMetric,
  StopRuleVerdict,
  TEAM_ERROR_CODES,
  TIMELINE_EVENT_TYPE_DISPLAY_LABEL,
  TIMELINE_EVENT_TYPE_LABEL,
  TOUCH_HISTORY_TYPES,
  TaskForceMetadataSchema,
  TeamCapability,
  TeamMetadataSchema,
  TeamRole,
  TeamStatus,
  TeamType,
  TimelineAttachmentType,
  TimelineEventType,
  UNPAGINATED_LIST_CAP,
  UPLOAD_ERROR_CODES,
  USERNAME_MAX_LENGTH,
  USERNAME_MIN_LENGTH,
  USERNAME_PATTERN,
  USER_ERROR_CODES,
  USER_STATUS_LABELS,
  UserLevel,
  UserRole,
  UserStatus,
  UsernameSchema,
  VIDEO_RIGHT_AXES,
  VIDEO_RIGHT_AXIS_LABEL,
  VIDEO_RIGHT_VALUES,
  VIDEO_RIGHT_VALUE_LABEL,
  VideoRightAxis,
  VideoRightValue,
  WARM_POOL_BASES,
  WARM_POOL_STATES,
  WIKI_AREAS,
  WIKI_AREA_LABELS,
  WIKI_AREA_SEEDS,
  WIKI_DISCUSSION_STATUSES,
  WIKI_DOCUMENT_KINDS,
  WIKI_ERROR_CODES,
  WIKI_HOME_TITLE,
  WIKI_PAGE_TITLE_PREFIX,
  WIKI_REVISION_KINDS,
  WIKI_SYSTEM_AREA_KEYS,
  WORKLOG_ERROR_CODES,
  WORK_DAY_CUTOFF_HOUR,
  WorkType,
  acceptQuest,
  activateScenario,
  adcodeIssueWarning,
  addDependency,
  addMember,
  alignCampaignPeriod,
  allowedBoostingTransitions,
  applyAdminEdit,
  applyCorrection,
  applyCropEdit,
  applyFeatureFlagOverrides,
  applySegmentTypeCorrection,
  approveActivity,
  approveQuest,
  approveSubmission,
  approvedOriginalSourceLabel,
  archiveActivity,
  archiveQuest,
  archiveScenario,
  archiveTeam,
  assertAdvertiserUsable,
  assertBoostingTransition,
  assertCanSubmit,
  assertRelationStateChange,
  assertSettlementTransition,
  assertStatus,
  assertThreadBody,
  assessOriginalIntegrity,
  authenticateSchema,
  backfillLinearDependencies,
  buildCursorResponse,
  buildDeepLinkQuery,
  buildScheduleRevisions,
  calculateAnnualLeaveEntitlement,
  calculateCampaignPrice,
  calculateCurrentWorkDuration,
  calculateDroppedSignals,
  calculateInternConversionDate,
  calculateInternConversionDday,
  calculateOpenReplacementSignals,
  calculateScenarioContractTargetRevisionSlots,
  calculateScenarioViewProgress,
  calculateServicePeriod,
  calculateTotalWorkDuration,
  campaignPeriod,
  campaignPeriodEnd,
  canArchiveScenario,
  canCommentOnAdcodeRequest,
  canCommentOnOperationalIssueReport,
  canCommentOnQuestTaskFeedback,
  canExportCreators,
  canRequestResubmit,
  canRestoreRosterDrop,
  canReviewAdcodeProof,
  canReviewCreatorMatching,
  canReviewProof,
  canSearchCreatorsCompanyWide,
  canTransitionQuest,
  canTransitionSettlement,
  canViewCreator,
  canWriteQuestTaskFeedback,
  captureInitialCreatorsRecruitedAt,
  cardSections,
  changePasswordSchema,
  checkQuestProductAttachment,
  classifyExpiredAttribution,
  classifyOriginalRecovery,
  classifyWorkSegments,
  clockIn,
  clockOut,
  closeAllOpenSegments,
  closeMissedAttendance,
  closeSegment,
  completeAcceptances,
  completeQuest,
  completeScenario,
  computeAttendanceAggregate,
  computeCycleKey,
  computeDistribution,
  computeNextCycle,
  computeQuestProgress,
  computeSegmentedGrossPay,
  computeTeamAggregate,
  computeWorldQuestLane,
  countPendingGroups,
  countWeekdays,
  createActivity,
  createAdvertiser,
  createClub,
  createDepartment,
  createIsHolidayFn,
  createQuest,
  createQuestTaskFeedback,
  createQuestTaskFeedbackComment,
  createRosterStatusValidator,
  createScenario,
  createScenarioOperationalIssueReportComment,
  createScenarioTemplate,
  createSegment,
  createSettlementCurrencyValidator,
  createTaskForce,
  creatorEmailSchema,
  currentOwnerUserId,
  currentVideoRights,
  defaultCampaignTimeline,
  deleteQuest,
  deriveBlockedUntil,
  deriveBoostingStage,
  deriveCampaignDifficulty,
  deriveCampaignType,
  deriveClockTimesFromSegments,
  deriveGuidelineDrafts,
  deriveOperationalSignalGap,
  deriveOutreachBlockedAt,
  deriveOutreachFunnel,
  deriveQuestDraftFromEvent,
  deriveRecruitRemaining,
  deriveRecruitmentPolicy,
  deriveRelationState,
  deriveRosterBallHolder,
  deriveRosterContentReviewDisplay,
  deriveRosterPhase,
  deriveScenarioProcedureProgress,
  deriveScenarioProcedureProgressFromSignals,
  deriveWarmPoolSummary,
  deriveWikiKind,
  describeQuestChain,
  detectMissedClockOut,
  discovererUserId,
  dropAcceptance,
  effectiveRelationHistory,
  endBreak,
  evaluateBlock,
  evaluateOutreachUnblock,
  evaluateRelationStateChange,
  evaluateTargetSlotConditions,
  evaluateUnblock,
  exceedsDailyMax,
  failAcceptances,
  failQuest,
  failScenario,
  featureFlags,
  fetchAllCursorPages,
  findRosterImportDuplicateKeys,
  findUnknownTemplateVariables,
  floorRelationState,
  forceCloseAttendance,
  formatDuration,
  formatElapsed,
  formatIsoCountryDisplay,
  formatKstDateTime,
  formatKstTime,
  formatOutreachDate,
  formatScenarioCode,
  gateWeight,
  gateWeightShares,
  gateWeightSnapshot,
  getActiveParticipantCount,
  getIsoCountryNameKo,
  getKstDateAfterDays,
  getKstDateString,
  getKstDayRange,
  getKstMonthDay,
  getKstMonthRange,
  getKstMonthStart,
  getKstPeriod,
  getKstWeekStart,
  getKstWorkDayLastInstant,
  getKstWorkDayRange,
  getLeader,
  getLedgerPeriod,
  getMembers,
  getPayPeriod,
  getPayPeriodByKey,
  getPayPeriodUtcWindow,
  getQuestAcceptanceBlockedReason,
  getViewState,
  groupPrerequisites,
  guidelineDeliveryCandidates,
  hasAdcodeCommentThread,
  hasDraftAwaitingReview,
  hasEmailOrTicket,
  hasTombstoneHistory,
  identifyByNameSchema,
  identifySchema,
  idleDays,
  instantiateTemplate,
  isAdvertiserReviewMode,
  isAdvertiserReviewVerdict,
  isAdvertiserRoundFree,
  isAllowedCropAspectRatio,
  isBalanceDeductible,
  isBlockActive,
  isBlockReasonKind,
  isCampaignAdCode,
  isCeoPolicyKey,
  isCheckpointRejectReasonKind,
  isCreatorPricePlatform,
  isCreatorResendOpen,
  isDepartedUserStatus,
  isExcludedFromTeamAverage,
  isFeatureActive,
  isGuidelineDeliveryCheckpoint,
  isHolidayForDate,
  isIso4217AlphaCode,
  isLeaveType,
  isManualRosterDropKind,
  isNotificationAllowed,
  isOccurredAtAcceptable,
  isOffDayForDate,
  isOnboardingQuestHiddenFor,
  isOwnerEligible,
  isParticipantInAudience,
  isPastDate,
  isPipelineStale,
  isQuestAcceptanceBlockedByCheckpoints,
  isQuestChainCleared,
  isQuestExpired,
  isReRecruitReasonKind,
  isReachableQuestState,
  isReasonValidForArea,
  isRelationState,
  isRequestableSettlementKind,
  isResolvedQuestProposalStatus,
  isRestrictedCreator,
  isRosterContentReview,
  isRosterDropKind,
  isRosterScheduleKind,
  isRosterTakedownRequester,
  isRosterUploadComplete,
  isSameInstantWithinTolerance,
  isScenarioSeedQuest,
  isSealedWorldQuestKind,
  isSettlementAmount,
  isSettlementCostBearer,
  isSettlementKind,
  isSettlementPayoutForm,
  isSettlementPayoutMethod,
  isSettlementStatus,
  isSettlementTermAllowedFor,
  isTikTokUrl,
  isTiktokNumericId,
  isUnblockedBy,
  isValidDateOnly,
  isValidIsoCountry,
  isVideoRightAxis,
  isVideoRightValue,
  isWikiPageTitle,
  isWritableRosterStatus,
  judgeRewardByPricing,
  judgeSettlementApproval,
  judgeStopRule,
  kstDate,
  kstDateToInstant,
  kstStartOfDay,
  lastTouchAt,
  latestScheduleByKind,
  lockActivity,
  loginSchema,
  mapRawAdcodeRow,
  mapRawRosterRow,
  matchHangul,
  missingRequiredRosterKeys,
  nextKstPeriod,
  normalizeAdcodeLabel,
  normalizeAdvertiserName,
  normalizeAdvertiserReviewModeInitialReason,
  normalizeCreatorHandle,
  normalizeGuidelineUrl,
  normalizeRosterLabel,
  normalizeVideoUrl,
  normalizeWikiTitle,
  onboardingQuestVisibilityWhere,
  ownerRevocationCause,
  ownerScopeMeasures,
  parseAspectRatio,
  parseDeepLinkFromQuery,
  parseLeaveType,
  parseStopRule,
  parseWikiLinks,
  parseWikiRedirect,
  paypalMeSchema,
  pickRepresentativeAdcodePerVideo,
  planApprovedOriginalWrite,
  planBoostingBackfill,
  planBoostingBackfillPath,
  pointsToKrw,
  previousKstPeriod,
  pricingNeedsReasonCode,
  prunePunchQueue,
  questDifficultyWeight,
  questStateOf,
  questTransitionSourcesTo,
  readCompanyDifficultyRanges,
  readResumePoint,
  recommendRegular,
  registerSchema,
  registerVerifySchema,
  regularParamsAt,
  rejectActivityCreation,
  rejectQuest,
  rejectSubmission,
  relationStateRank,
  removeMember,
  renderReplyTemplate,
  reorderQuests,
  requiredRosterKeyLabel,
  requiresAdvertiserApproval,
  requiresExecutiveApproval,
  requiresSettlementClearanceReason,
  resetFeatureFlags,
  resetPasswordSchema,
  resolveCompensationAt,
  resolveDifficultyPricing,
  resolveLeaveApprovalAuthority,
  resolveProofGateOwners,
  resolveQualitativeGateOwners,
  resolveTargetSlotRequirements,
  resolveWikiArea,
  restoreTeam,
  resumeAttendance,
  reviewFileIntegrityAction,
  revokeAllSessionsSchema,
  revokeWorldQuest,
  rosterImportMatchKey,
  rosterPriceCurrency,
  rosterScheduleConfirmInputSchema,
  rosterScheduleView,
  rosterWritableStatusValidator,
  scheduleConfirmationState,
  seedCheckpointDiscriminator,
  selectApprovedOriginalFile,
  selectProofReminderTargets,
  sendOtpSchema,
  setAdvertiserActive,
  shouldIngestFormResponses,
  snapshotConditionsForWrite,
  sortRelationHistory,
  splitKakaoChannelName,
  splitLeaveDaysByServiceYear,
  splitQuestState,
  startBreak,
  stripCreatorHandlePrefix,
  submitForApproval,
  submitPiecework,
  summarizeScenarioOperationalHealth,
  syncSegmentBoundaries,
  tagQuestToScenario,
  targetSlotOverridesSchema,
  targetSlotParticipantConditionsSchema,
  targetSlotRequirementsSchema,
  teamDifficultyPricingSchema,
  toAttendancePolicy,
  toKstDateString,
  toKstParts,
  toKstTimeMinutes,
  toKstWorkDateString,
  toParticipantConditions,
  toUtcDateString,
  transferLeadership,
  triggerOutbreak,
  uniqueWikiLinkTargets,
  unlockActivity,
  unpricedQuestWhere,
  untagQuestFromScenario,
  updateAdvertiser,
  updateScenario,
  updateTeamCapabilities,
  validateAdvertiserReviewModeChange,
  validateCampaignTimeline,
  validateCeoPolicyValue,
  validateCheckpointRewardBalanced,
  validateCheckpointRewardTotal,
  validateHalfDayRequest,
  validateLeaveBalance,
  validateMissedClockInTime,
  validateMissedClockOutTime,
  validateOriginalProvenance,
  validateSegmentTimes,
  validateTimeOrder,
  validateTimelineAttachment,
  validateTimelineEvent,
  verifyIdentitySchema,
  verifyOtpSchema,
  visibleReportsForViewer,
  wikiParentTitle,
  withdrawAcceptances,
  withdrawQuest
} from "./chunk-P7KRU2Z3.mjs";

// src/format/date.ts
import {
  format,
  getDay,
  startOfDay,
  startOfMonth,
  startOfWeek,
  eachDayOfInterval,
  isWeekend
} from "date-fns";
import { TZDate } from "@date-fns/tz";
var WEEKDAYS = ["\uC77C", "\uC6D4", "\uD654", "\uC218", "\uBAA9", "\uAE08", "\uD1A0"];
function formatDateKo(dateStr) {
  const d = new TZDate(dateStr + "T00:00:00+09:00", "Asia/Seoul");
  return `${d.getMonth() + 1}/${d.getDate()} (${WEEKDAYS[getDay(d)]})`;
}
function formatDateDotKo(dateStr) {
  const d = new TZDate(dateStr + "T00:00:00+09:00", "Asia/Seoul");
  return `${format(d, "MM.dd")} (${WEEKDAYS[getDay(d)]})`;
}
function formatMonthDayKo(input, options) {
  if (!input) return "";
  const d = /^\d{4}-\d{2}-\d{2}$/.test(input) ? new TZDate(input + "T00:00:00+09:00", "Asia/Seoul") : new TZDate(new Date(input), "Asia/Seoul");
  if (Number.isNaN(d.getTime())) return "";
  const base = `${d.getMonth() + 1}\uC6D4 ${d.getDate()}\uC77C`;
  return options?.weekday ? `${base} (${WEEKDAYS[getDay(d)]})` : base;
}
function getLocalToday() {
  return getLocalDateString(/* @__PURE__ */ new Date());
}
function getLocalDateString(date) {
  return format(date, "yyyy-MM-dd");
}
function getLocalStartOfDay(date = /* @__PURE__ */ new Date()) {
  return startOfDay(date);
}
function getLocalMonthStart(date = /* @__PURE__ */ new Date()) {
  return startOfMonth(date);
}
function getLocalWeekStart(date = /* @__PURE__ */ new Date()) {
  return startOfWeek(date, { weekStartsOn: 1 });
}
function datetimeLocalToKstISO(value) {
  const hasSeconds = value.split("T")[1]?.includes(":") && value.split(":").length >= 3;
  const normalized = hasSeconds ? value : `${value}:00`;
  return `${normalized}+09:00`;
}
function getBusinessDaysUpToToday(date = /* @__PURE__ */ new Date(), holidays) {
  const year = date.getFullYear();
  const month = date.getMonth();
  const today = date.getDate();
  const start = new Date(year, month, 1);
  const end = new Date(year, month, today);
  const days = eachDayOfInterval({ start, end });
  return days.filter((d) => {
    if (isWeekend(d)) return false;
    if (holidays) {
      const dateStr = format(d, "yyyy-MM-dd");
      if (holidays.has(dateStr)) return false;
    }
    return true;
  }).length;
}
function normalizeDeadline(v) {
  return /^\d{4}-\d{2}-\d{2}$/.test(v) ? `${v}T23:59` : v;
}

// src/format/time.ts
var timeShortFormat = new Intl.DateTimeFormat("ko-KR", {
  hour: "2-digit",
  minute: "2-digit",
  hour12: false
});
function formatTimeShort(iso) {
  if (!iso) return "-";
  return timeShortFormat.format(new Date(iso));
}
function formatLocalDateTimeInput(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// src/format/duration.ts
function sumSegmentMs(segments, type) {
  return segments.filter((seg) => seg.type === type && seg.endAt).reduce(
    (sum, seg) => sum + Math.max(0, new Date(seg.endAt).getTime() - new Date(seg.startAt).getTime()),
    0
  );
}
function formatDurationCompact(ms) {
  if (!Number.isFinite(ms) || ms < 0) return "0h 0m";
  const totalMinutes = Math.floor(ms / 6e4);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}h ${minutes}m`;
}
function formatMs(ms) {
  if (ms == null) return "-";
  if (ms < 1e3) return `${Math.round(ms)}ms`;
  return `${Number((ms / 1e3).toFixed(1))}s`;
}
function formatOvertimeHours(ms) {
  if (!Number.isFinite(ms) || ms < 0) return "0h";
  const hours = Math.floor(ms / 36e5);
  return `${hours}h`;
}
function formatDurationKo(ms) {
  if (!Number.isFinite(ms) || ms < 0) return "0\uBD84";
  const h = Math.floor(ms / 36e5);
  const m = Math.floor(ms % 36e5 / 6e4);
  if (h === 0) return `${m}\uBD84`;
  if (m === 0) return `${h}\uC2DC\uAC04`;
  return `${h}\uC2DC\uAC04 ${m}\uBD84`;
}

// src/format/quest.ts
var QUEST_STATUS_TO_FE = {
  [QuestStatus.DRAFT]: "pending",
  [QuestStatus.ACTIVE]: "in_progress",
  [QuestStatus.LOCKED]: "locked",
  [QuestStatus.COMPLETED]: "completed",
  [QuestStatus.FAILED]: "failed",
  [QuestStatus.WITHDRAWN]: "withdrawn",
  [QuestStatus.ARCHIVED]: "archived"
};
function questStatusToFeStatusOrPending(status) {
  return questStatusToFeStatus(status) ?? "pending";
}
function questStatusToFeStatus(status) {
  if (status == null) return void 0;
  return QUEST_STATUS_TO_FE[status];
}
var QUEST_DIFFICULTY_TO_RARITY = {
  [QuestDifficulty.COMMON]: "common",
  [QuestDifficulty.UNCOMMON]: "uncommon",
  [QuestDifficulty.RARE]: "rare",
  [QuestDifficulty.EPIC]: "epic",
  [QuestDifficulty.LEGENDARY]: "legendary"
};
function questDifficultyToRarity(difficulty) {
  if (difficulty == null) return void 0;
  return QUEST_DIFFICULTY_TO_RARITY[difficulty];
}

// src/format/attachment-name.ts
function attachmentDownloadName(name, source) {
  const trimmed = name?.trim();
  if (trimmed) return trimmed;
  const pathname = source.split(/[?#]/)[0] ?? "";
  const tail = decodeURIComponent(pathname.split("/").pop() ?? "");
  const dot = tail.lastIndexOf(".");
  const stem = dot > 0 ? tail.slice(0, dot) : tail;
  const ext = dot > 0 ? tail.slice(dot + 1) : "";
  const base = `\uCCA8\uBD80\uD30C\uC77C-${stem.slice(0, 8)}`;
  return ext ? `${base}.${ext}` : base;
}

// src/format/usage-ratio.ts
function formatUsageRatioPct(numerator, denominator) {
  if (denominator === 0) return null;
  return `${Math.round(numerator / denominator * 100)}%`;
}

// src/features/notification/category.ts
var NOTIFICATION_CATEGORIES = [
  "attendance",
  "leave",
  "quest",
  "chat",
  "point",
  "reservation",
  "system"
];
function toNotificationCategory(type) {
  if (type === "MENTION" || type === "REPLY" || type === "PIN") return "chat";
  if (type.startsWith("ATTENDANCE_")) return "attendance";
  if (type.startsWith("LEAVE_")) return "leave";
  if (type.startsWith("QUEST_") || type.startsWith("CHECKPOINT_") || type.startsWith("CP_") || type.startsWith("OUTBREAK_") || type.startsWith("ADCODE_") || // 진행 책임자 지정·회수는 'quest' 토글 그룹이다. 기본 폴백('system')으로 두면 시스템 알림을
  // 끈 사용자가 "진행 책임자로 지정되었습니다" 같은 본인 대상 통보를 놓친다 — 인사 성격이라
  // 놓치면 복구 경로가 없다. 착지 창도 퀘스트 창이라 사용자 인식과도 맞는다.
  // 접두사(startsWith('SCENARIO_')) 대신 **명시 비교**인 이유 — 접두사로 잡으면 향후 추가될
  // 시스템 성격의 시나리오 알림(마감 임박 등)까지 아무 신호 없이 quest 로 편입된다.
  // 새 SCENARIO_* 타입은 여기에 의식적으로 한 줄씩 추가할 것(미등록분은 'system' 폴백).
  type === "SCENARIO_PROGRESS_OWNER_ASSIGNED" || type === "SCENARIO_PROGRESS_OWNER_REVOKED" || // 전사 공개모집 철회(E8). 형제 OUTBREAK_REVOKED 는 접두사로 자동 편입되지만 이쪽은
  // 접두사가 달라 자동으로 안 잡힌다 — 빠뜨리면 'system' 폴백으로 끌려가 퀘스트 토글을
  // 켠 지원자가 본인이 지원한 모집이 닫힌 사실을 못 받는다.
  type === "OPEN_CALL_REVOKED" || // 로스터 정체 다이제스트도 착지 창이 퀘스트 창(시나리오 브리프)이라 'quest' 토글 그룹이다.
  // 'system' 폴백에 두면 시스템 알림을 끈 진행 책임자·팀장이 방치 경보를 통째로 놓치는데,
  // 이 알림이 미는 쪽 전부라 놓치면 정체가 표를 열 때까지 그대로 남는다.
  // SCENARIO_* 선례와 같이 접두사가 아니라 **명시 비교**다 — 접두사로 잡으면 향후 추가될
  // 시스템 성격의 캠페인 알림까지 아무 신호 없이 quest 로 편입된다.
  type === "CAMPAIGN_ROSTER_STALLED" || // 크리에이터 회신 도착도 착지가 캠페인 브리프라 같은 토글 그룹이다.
  type === "CREATOR_MAIL_REPLY_RECEIVED" || // 회신 방치 에스컬레이션도 같은 착지다. 'system' 폴백에 두면 시스템 알림을 끈 팀장이
  // 방치 경보를 통째로 놓치는데, 이 알림이 미는 쪽 전부라 놓치면 회신이 그대로 묻힌다.
  type === "CREATOR_MAIL_REPLY_NEGLECTED" || // 로스터 밖 섭외가 PREMIUM 관계에 붙었다는 알림도 같은 섭외 업무다. 'system' 폴백에 두면
  // 시스템 알림을 끈 담당자가 팀원의 연락을 모른 채 같은 크리에이터에 겹쳐 연락한다.
  type === "CREATOR_RELATION_PREMIUM_CONTACT_RECORDED" || // 섭외 예약 알림도 착지가 캠페인 브리프다. 'system' 폴백에 두면 시스템 알림을 끈 사람이
  // 예약이 취소된 사실을 놓쳐 메일이 안 나간 줄 모른다.
  type === "OUTREACH_RESERVATION_ALERT" || // 영상 등록 결과도 착지가 캠페인 브리프(로스터)라 같은 토글 그룹이다. 실패를 놓치면 그 영상은
  // 오류함에 오를 때까지 아무도 모른 채 추적되지 않는다.
  type === "VIDEO_RETENTION_ATTENTION" || type === "VIDEO_RETENTION_FINAL" || type === "VIDEO_TRACKING_REGISTERED" || type === "VIDEO_TRACKING_REGISTRATION_FAILED" || type === "VIDEO_TRACKING_REPLACEMENT_CONFIRM_REQUESTED") {
    return "quest";
  }
  if (type.startsWith("POINT_") || type.startsWith("RANK_")) return "point";
  if (isSettlementNotificationType(type)) return "point";
  if (type.startsWith("CLUB_")) return "quest";
  if (type.startsWith("RESERVATION_")) return "reservation";
  if (type === "BUG_REPORT_STALE_DIGEST") return "system";
  if (type === "OPS_SIGNAL_REPORT_CREATED" || type === "OPS_SIGNAL_HELP_NEEDED" || type === "OPS_SIGNAL_COMMENT_ADDED" || type === "OPS_SIGNAL_STATUS_CHANGED") {
    return "system";
  }
  return "system";
}

// src/features/notification/mobile-route.ts
function getMobileNotificationRoute(notification) {
  const { type } = notification;
  if (type === "MENTION" || type === "REPLY" || type === "PIN") {
    return { kind: "chat", channelId: notification.channelId };
  }
  if (type.startsWith("ATTENDANCE_")) {
    return { kind: "attendance" };
  }
  return null;
}

// src/features/notification/relative-time.ts
import { TZDate as TZDate2 } from "@date-fns/tz";
var MINUTE_MS = 6e4;
var HOUR_MS = 60 * MINUTE_MS;
var DAY_MS = 24 * HOUR_MS;
function formatNotificationRelativeTime(iso, now = /* @__PURE__ */ new Date()) {
  const created = new Date(iso);
  const diff = now.getTime() - created.getTime();
  if (diff < MINUTE_MS) return "\uBC29\uAE08 \uC804";
  if (diff < HOUR_MS) return `${Math.floor(diff / MINUTE_MS)}\uBD84 \uC804`;
  if (diff < DAY_MS) return `${Math.floor(diff / HOUR_MS)}\uC2DC\uAC04 \uC804`;
  if (diff < 7 * DAY_MS) return `${Math.floor(diff / DAY_MS)}\uC77C \uC804`;
  const kst = new TZDate2(created, "Asia/Seoul");
  const y = kst.getFullYear();
  const m = String(kst.getMonth() + 1).padStart(2, "0");
  const d = String(kst.getDate()).padStart(2, "0");
  return formatDateKo(`${y}-${m}-${d}`);
}
export {
  ABSENCE_OPTION_CONTENT,
  ADCODE_REQUEST_COMMENT_MAX_LENGTH,
  ADJUST_REASON_CATEGORIES,
  ADJUST_REASON_CATEGORY_LABELS,
  ADVERTISER_REVIEW_MODES,
  ADVERTISER_REVIEW_MODE_LABEL,
  ADVERTISER_REVIEW_VERDICTS,
  ADVERTISER_REVIEW_VERDICT_LABEL,
  AGENT_ERROR_CODES,
  ALLOWED_BUCKETS,
  ALLOWED_MIME_TYPES,
  ANOMALY_LABELS,
  APPROVAL_HISTORY_AUDIT_TARGETS,
  APP_EVENTS,
  APP_VIEWS,
  APP_VIEW_REGISTRY,
  ARCHIVE_COPY_GRACE_MINUTES,
  ASSISTANT_ERROR_CODES,
  ASSISTANT_WAITING_TIMEOUT_MS,
  ATTENDANCE_ERROR_CODES,
  AUDIT_LOG_ACCESS_ACTION,
  AUDIT_LOG_EXPORT_MAX_ROWS,
  AUDIT_LOG_PII_RETENTION_DAYS,
  AUDIT_LOG_ROW_RETENTION_DAYS,
  AUDIT_LOG_ROW_RETENTION_EXEMPTIONS,
  AUDIT_LOG_SYSTEM_ACTION,
  AUDIT_PATH_SCOPED_SENSITIVE_KEYS,
  AUTH_ERROR_CODES,
  AUTO_FILL_TASK_MEMO,
  AUTO_FILL_TASK_TITLE,
  AdcodeLabelKey,
  AdvertiserReviewMode,
  AdvertiserReviewVerdict,
  AgentConnectionType,
  AgentMessageType,
  AgentStatus,
  ApprovedOriginalFileOrigin,
  ApprovedOriginalReceivedVia,
  ApprovedOriginalSource,
  ApprovedOriginalState,
  AttachmentType,
  AttendanceStatus,
  BAND_MEDIAN,
  BLOCK_REASON_KINDS,
  BOOSTING_RESUME_EDGES,
  BOOSTING_STAGE_ORDER,
  BUDGET_LEDGER_ERROR_CODES,
  BUDGET_TYPE_LABELS,
  BUG_REPORT_PROCESSED_STATUSES,
  BUG_REPORT_QUEST_TEAM_NAME,
  BULK_ARCHIVE_MAX_IDS,
  BULK_VOID_MAX,
  BoostingFlagWarning,
  BoostingStage,
  Brand,
  BugReportAttachmentSchema,
  BugReportEventType,
  BugReportStatus,
  BugReportType,
  CAMPAIGN_ADCODE_DRY_RUN_MAX_ROWS,
  CAMPAIGN_ADCODE_DRY_RUN_PREVIEW_LIMIT,
  CAMPAIGN_AD_CODE_PATTERN,
  CAMPAIGN_DIFFICULTY_CONDITIONS,
  CAMPAIGN_RETRO_LESSON,
  CAMPAIGN_ROSTER_IMPORT_MAX_ROWS,
  CAMPAIGN_ROSTER_SENSITIVE_KEYS,
  CAMPAIGN_SLOT_PRICE,
  CAMPAIGN_TIMELINE_LABEL_MAX,
  CAMPAIGN_TIMELINE_MAX_ENTRIES,
  CAMPAIGN_TIMELINE_MILESTONE_LABEL,
  CANCEL_WAIT_MS,
  CANDIDATE_CONTACT_STATES,
  CANDIDATE_QUERY_STATES,
  CEO_POLICY_DEFAULTS,
  CEO_POLICY_EFFECT_NOTES,
  CEO_POLICY_KEYS,
  CEO_POLICY_LABELS,
  CHAIN_OPEN_WHERE,
  CHANNEL_DESCRIPTION_MAX_LENGTH,
  CHANNEL_NOTIFY_LEVELS,
  CHAT_ERROR_CODES,
  CHECKIN_INTERVAL_GRADE_KEYS,
  CHECKIN_INTERVAL_MIN_SAMPLE,
  CHECKPOINT_ERROR_CODES,
  CHECKPOINT_ORDER_MIN,
  CHECKPOINT_REVISION_FIELDS,
  CHECKPOINT_TRANSITIONS,
  CHECKPOINT_UNIT_MAX,
  CLIENT_PLATFORMS,
  CLIENT_TELEMETRY_EVENT_NAMES,
  CLUB_DURATION_CAP_MS,
  CLUB_ERROR_CODES,
  CLUB_TINT_PALETTE,
  COMMON_ERROR_CODES,
  CONDITION_AGREED_EVENT,
  CONSISTENCY_RULES,
  CONTRACT_PARTY_KINDS,
  CREATOR_COLLECTION_STATES,
  CREATOR_EMAIL_MAX_LENGTH,
  CREATOR_LIST_CHANNELS,
  CREATOR_LIST_CONTACT_BATCH,
  CREATOR_LIST_CONTACT_LOG_NOTICE,
  CREATOR_LIST_DOWNLOAD_ROUTE,
  CREATOR_LIST_FILE_LIMIT,
  CREATOR_LIST_FILE_LIMIT_MAX,
  CREATOR_LIST_REDOWNLOAD_DAYS,
  CREATOR_LIST_RETENTION_DAYS,
  CREATOR_MAIL_CONNECTION_STATUSES,
  CREATOR_MAIL_CONNECT_FAILURES,
  CREATOR_MAIL_DRAFT_HEARTBEAT_MS,
  CREATOR_MAIL_DRAFT_LEASE_MS,
  CREATOR_PII_FIELD_KEYS,
  CREATOR_PII_FIELD_MAX_LENGTH,
  CREATOR_PII_PURGE_BLOCKED,
  CREATOR_PII_PURGE_CAUSES,
  CREATOR_PII_RETENTION_MONTHS,
  CREATOR_PIPELINE_MAX_LAG_MS,
  CREATOR_PRICE_PLATFORMS,
  CREATOR_RELATION_HANDLE_RELATIONS_OVERFLOW,
  CREATOR_RELATION_INVALID_TRANSITION,
  CREATOR_RELATION_LIST_SORTS,
  CREATOR_RELATION_LIST_TAKE,
  CREATOR_RELATION_SEEDING_TEAM_IDS_KEY,
  CREATOR_RELATION_SEEDING_TEAM_INVALID,
  CREATOR_RELATION_SENSITIVE_KEYS,
  CREATOR_RELATION_SOURCE_SYSTEM,
  CREATOR_RELATION_VIEWS,
  CREATOR_RESEND_CLOSED_MESSAGE,
  CREATOR_SEARCH_QUERY_MAX,
  CREATOR_SEARCH_QUERY_MIN,
  CREATOR_UNKNOWN_TO_SOURCE,
  CREATOR_VIEW_METRICS_IDS_MAX,
  CREVASSE_EMAIL_DOMAIN,
  CROP_ASPECT_PRESETS,
  CYCLE_KEY_NONE,
  CampaignAdcodeDryRunConflictCode,
  CampaignAdcodeDryRunOutcome,
  CampaignAdcodeDryRunUnresolvedCode,
  CampaignAdcodeImportOutcome,
  CampaignDifficulty,
  CampaignRosterImportOutcome,
  CampaignRosterWarningCode,
  CampaignTimelineMilestone,
  CampaignVideoReviewFileKind,
  CampaignVideoReviewFileState,
  CampaignVideoReviewSourceType,
  CampaignVideoReviewVerdict,
  CapabilityPermissionModifiers,
  CheckpointOrderSchema,
  CheckpointRejectReasonKind,
  CheckpointRevisionKind,
  CheckpointStatus,
  CheckpointType,
  ClubFeedStatus,
  ClubMetadataSchema,
  ClubPollStatus,
  CompensationType,
  ConversationEntityType,
  CorrectionStatus,
  CreateKnowledgeAuthorityDecisionSchema,
  CreateKnowledgeSourceSchema,
  CreatorPricePlatform,
  CreatorVisibilityTier,
  CrevasseEmailSchema,
  DEEP_LINK_VIEW_PARAM,
  DEFAULT_ADVERTISER_REVIEW_MODE,
  DEFAULT_AGENT_SLUG,
  DEFAULT_FEATURE_FLAGS,
  DEFAULT_OUTREACH_DATE_FORMAT,
  DEFAULT_PAGE_LIMIT,
  DEFAULT_PAY_DAY,
  DEFAULT_POINT_TO_KRW_RATE,
  DEFAULT_ROSTER_STATUS,
  DEPARTED_USER_STATUSES,
  DEV_VISIBLE_HIDDEN_FLAGS,
  DISTRIBUTION_KINDS,
  DIVIDEND_POOL_RATE,
  DOKKAEBI_EVENTS,
  DOKKAEBI_PROACTIVE_TITLE_PREFIX,
  DOKKAEBI_SYSTEM_USER_ID,
  DOMESTIC_QUEUE_TAB_STATUS,
  DOMESTIC_TARGET_COUNTRIES,
  DRAFT_REVIEW_ROUND_RISK_THRESHOLD,
  EMAIL_LABEL_KEYS,
  EXCLUSION_LOCK_LEAD_MS,
  EXPIRY_CLOSE_DISPOSITIONS,
  EXPIRY_CLOSE_EVENT_PREFIX,
  EmailSchema,
  FIRST_CONTRACT_VIDEO_NO,
  FLEX_WEEKLY_WORK_THRESHOLD_MS,
  FREE_CROP_MAX_RATIO,
  FREE_CROP_MIN_RATIO,
  FinanceLedgerNavigationSchema,
  GetKnowledgeDocumentQuerySchema,
  GuidelineReviewItemKind,
  HolidayPaidType,
  IDLE_WARN_DAYS,
  INACTIVE_ATTENDANCE_STATUSES,
  INFO_SCORE,
  INTERN_CONVERSION_REVIEW_MONTHS,
  ISO8601_PATTERN,
  ISO_COUNTRIES,
  ISO_COUNTRY_BY_CODE,
  Iso8601Schema,
  IsoCountryCodeArraySchema,
  IsoCountryCodeSchema,
  KNOWLEDGE_AUTHORITY_STATUSES,
  KNOWLEDGE_DOCUMENT_AVAILABILITIES,
  KNOWLEDGE_INDEXING_STATUSES,
  KNOWLEDGE_INDEX_STATES,
  KNOWLEDGE_INITIAL_CHUNKER_VERSION,
  KNOWLEDGE_INITIAL_EXTRACTOR_VERSION,
  KNOWLEDGE_SOURCE_MEMBER_ROLES,
  KNOWLEDGE_SYNC_JOB_STATES,
  KnowledgeIndexConfigSchema,
  KnowledgeSourceMemberSchema,
  LEADERBOARD_PERIODS,
  LEAVE_ERROR_CODES,
  LEAVE_TYPE_LABELS,
  LEGACY_CHECKPOINT_STATUS,
  LEGAL_NAME_MAX_LENGTH,
  LEGAL_NAME_MIN_LENGTH,
  LEVEL_LABELS,
  LINKED_CHAIN_OPEN_WHERE,
  LeaveApprovalStatus,
  LeaveApprovalType,
  LeaveProofStatus,
  LeaveStatus,
  LeaveType,
  LegalNameSchema,
  LoginTicketSchema,
  MANAGER_BONUS_REASON_MESSAGE,
  MAX_CORRECTION_SPAN_MS,
  MAX_FILE_SIZE,
  MAX_QUESTS_PER_SCENARIO,
  MAX_VIDEO_REVIEW_FILE_BYTES,
  MCP_FINANCIAL_WRITE_SCOPES,
  MCP_IMPERSONATE_SCOPE,
  MCP_SCOPES,
  MCP_SCOPE_ISSUE_REQUIREMENTS,
  MCP_SCOPE_PERMISSIONS,
  MCP_SCOPE_PRESETS,
  MCP_TOKEN_PREFIX,
  MCP_TOKEN_RANDOM_BYTES,
  MESSAGE_CONTENT_MAX_LENGTH,
  MIN_WORK_SEGMENT_BEFORE_BREAK_MS,
  MONTHLY_RETRO_METRIC_KEYS,
  MONTHLY_RETRO_STATUSES,
  MONTHLY_RETRO_UNDATED,
  MUST_FIX_SCORE,
  ManagerBonusReasonCode,
  ManagerBonusSkipReason,
  MappingWarningCode,
  MessageContentSchema,
  NARRATOR_AGENT_SLUG,
  NOTIFICATION_CATEGORIES,
  NOTIFICATION_FEATURE_MAP,
  NOTIFICATION_OPT_IN_TOPICS,
  NOTIFICATION_SCOPES,
  NOTIFICATION_TYPES,
  NavigationContextSchema,
  OAUTH_AUTHORIZATION_CODE_TTL_SECONDS,
  OAUTH_AUTHORIZE_REQUEST_TTL_SECONDS,
  OAUTH_OFFLINE_ACCESS_SCOPE,
  OAUTH_REFRESH_TOKEN_PREFIX,
  OAUTH_REFRESH_TOKEN_TTL_SECONDS,
  ONBOARDING_ALLOWED_VIEWS,
  ONBOARDING_QUEST_ORIGIN,
  OPERATIONAL_REASONS_BY_AREA,
  OUTREACH_BLOCKING_VARIABLES,
  OUTREACH_CTA_ALIGNS,
  OUTREACH_CTA_PRESETS,
  OUTREACH_CTA_WIDTHS,
  OUTREACH_DATE_FORMATS,
  OUTREACH_HANDLE_FIELD_KEYS,
  OUTREACH_METRIC_KEYS,
  OUTREACH_OUTLIER_GROUP_CODES,
  OUTREACH_OUTLIER_GROUP_RULES,
  OUTREACH_OUTLIER_OTHER_TEAM_DAYS,
  OUTREACH_OUTLIER_OTHER_TEAM_EVENTS,
  OUTREACH_OUTLIER_PAGE_MAX,
  OUTREACH_OUTLIER_PRECEDENCE,
  OUTREACH_OUTLIER_PREVIEW_DEFAULT,
  OUTREACH_PICK_COUNT_MAX,
  OUTREACH_PRESENCE_HEARTBEAT_MS,
  OUTREACH_PRESENCE_LEASE_MS,
  OUTREACH_REINCLUDE_REASONS,
  OUTREACH_RETENTION_POLICY,
  OUTREACH_ROUND_MAX_HANDLES,
  OUTREACH_SELECTION_MAX_IDS,
  OUTREACH_SELECTION_MODES,
  OUTREACH_SUPPRESSION_REASONS,
  OWNER_CHANGE_CAUSES,
  OffDayApprovalStatus,
  PAGE_VIEW_RETENTION_DAYS,
  PASSWORD_MIN_LENGTH,
  PASSWORD_PATTERN,
  PAYOUT_LABEL_KEYS,
  PERFORMANCE_REPORT_ANCHOR_DAYS,
  PERFORMANCE_REPORT_STATUS,
  PII_LABEL_KEYS,
  POINTS_MIN,
  POINT_ERROR_CODES,
  POINT_HISTORY_EXPORT_MAX_ROWS,
  POINT_TEAM_ATTRIBUTION_IS_POINT_IN_TIME,
  POINT_TEAM_ATTRIBUTION_LABELS,
  POINT_TEAM_UNATTRIBUTED,
  POINT_TEAM_UNATTRIBUTED_LABEL,
  POLLING_STALE_THRESHOLD_MINUTES,
  POSTURE_CREATED_REASON,
  POSTURE_MIGRATED_REASON,
  POSTURE_STALE_DAYS,
  POST_RETENTION_DAYS,
  PRICING_GROUND_PREFIX,
  PRICING_REASON_CODES,
  PROOF_DESCRIPTION_MAX_LENGTH,
  PROOF_ERROR_CODES,
  PROOF_FAILURE_STAGES,
  PROOF_REMINDER_SUBMITTED_STATUSES,
  PROOF_REVIEW_OVERDUE_BUSINESS_DAYS,
  PROOF_SUBMISSION_PATHS,
  PROPOSAL_ERROR_CODES,
  PUNCH_QUEUE,
  PasswordSchema,
  PayoutStatus,
  PieceworkActivityStatus,
  PieceworkAudienceScope,
  PieceworkCycle,
  PieceworkSubmissionStatus,
  PointHistoryType,
  PointsSchema,
  ProofStatus,
  QUEST_DIFFICULTY_CRITERIA_TEXT,
  QUEST_DIFFICULTY_GUIDE,
  QUEST_DIFFICULTY_LEVELS,
  QUEST_ERROR_CODES,
  QUEST_PROPOSAL_DESCRIPTION_MAX_LENGTH,
  QUEST_PROPOSAL_TITLE_MAX_LENGTH,
  QUEST_QUESTION_NO_REPLY_MARKERS,
  QUEST_STATES,
  QUEST_STATUS_TO_FE,
  QUEST_TASK_ERROR_CODES,
  QUEST_TASK_TITLE_MAX,
  QUEST_TEMPLATE_ERROR_CODES,
  QUEST_TRANSITIONS,
  QUEST_UPDATED_FIELD_LABELS,
  QUEST_WEIGHT_ALPHA_DEFAULT,
  QUEST_WEIGHT_FORMULA_VERSION,
  QuestAcceptanceStatus,
  QuestApprovalStatus,
  QuestDifficulty,
  QuestPresenceEntrySchema,
  QuestPresenceUserSchema,
  QuestProductAttachmentViolation,
  QuestProposalDescriptionSchema,
  QuestProposalStatus,
  QuestProposalTitleSchema,
  QuestScope,
  QuestStatus,
  QuestTargetType,
  QuestTaskCloseReason,
  QuestTaskCreatedVia,
  QuestTaskStatus,
  QuestTaskValueRevisionSource,
  RANK_ERROR_CODES,
  REACH_CHANNELS,
  REACH_CHANNEL_LABELS,
  REALTIME_TOKEN_REFRESH_LEAD_SECONDS,
  REALTIME_TOKEN_TTL_SECONDS,
  REGULAR_PARAMS,
  RELATION_CONTACT_CHANNELS,
  RELATION_CONTACT_CHANNEL_LABELS,
  RELATION_HISTORY_ORIGINS,
  RELATION_HISTORY_TYPES,
  RELATION_STATES,
  REPLY_NEGLECT_BUSINESS_DAYS,
  REPLY_TEMPLATE_KINDS,
  REPLY_TEMPLATE_LAYERS,
  REPLY_TEMPLATE_STAGES,
  REPLY_TEMPLATE_VARIABLE_KEYS,
  RESERVATION_CONFIRM_POLL_MS,
  RESERVATION_CONFIRM_WINDOW_MS,
  RESERVATION_MAX_ATTEMPTS,
  RESERVATION_RANGE_MAX_DAYS,
  RESERVATION_WATCH_OFFSETS_MS,
  RESUME_POINT_MAX_LENGTH,
  REVERSIBLE_POINT_HISTORY_TYPES,
  REVIEWED_HISTORY_MAX_DAYS,
  REWARD_POINTS_MIN,
  RE_RECRUIT_REASON_KINDS,
  ROSTER_CHANGE_KINDS,
  ROSTER_CONTENT_REVIEWS,
  ROSTER_CONTENT_REVIEW_DISPLAY_LABEL,
  ROSTER_DELIVERY_RULES,
  ROSTER_DRAFT_ARRIVAL_STATUSES,
  ROSTER_DROP_EVENT_ACTIONS,
  ROSTER_DROP_KINDS,
  ROSTER_DROP_KIND_LABEL,
  ROSTER_LABEL_ALIASES,
  ROSTER_LOCKABLE_FIELDS,
  ROSTER_LOCK_ACTIONS,
  ROSTER_MANUAL_COMMUNICATION_CHANNELS,
  ROSTER_MANUAL_COMMUNICATION_EVENT_TYPES,
  ROSTER_MANUAL_COMMUNICATION_TARGET_ROLES,
  ROSTER_MANUAL_DROP_KINDS,
  ROSTER_NO_REPLY_NUDGE_THRESHOLD,
  ROSTER_PRICE_PROPOSERS,
  ROSTER_SCHEDULE_KINDS,
  ROSTER_SHIPPING_EXPORT_FIELDS,
  ROSTER_STALL_KIND_LABEL,
  ROSTER_STALL_THRESHOLD_DAYS,
  ROSTER_STATUSES,
  ROSTER_TAKEDOWN_REQUESTERS,
  ROSTER_WRITABLE_STATUSES,
  RelationStateChangeError,
  RewardPointsSchema,
  RolePermissions,
  RosterAssigneeChangeCause,
  RosterBallHolder,
  RosterContentReview,
  RosterContentReviewDisplay,
  RosterDeliveryBlock,
  RosterDeliveryCondition,
  RosterDraftEventKind,
  RosterDropEventAction,
  RosterDropKind,
  RosterLabelKey,
  RosterPhase,
  RosterPriceProposer,
  RosterScheduleKind,
  RosterShippingState,
  RosterStallKind,
  RosterStatus,
  RosterTakedownRequester,
  SCENARIO_CREATOR_COUNT_MAX,
  SCENARIO_CREATOR_COUNT_MIN,
  SCENARIO_ERROR_CODES,
  SCENARIO_OPERATIONAL_ISSUE_REPORT_COMMENT_MAX_LENGTH,
  SCENARIO_OPERATIONAL_SIGNAL_GAP_ALIGNED_HOURS,
  SCENARIO_OPERATIONAL_SIGNAL_REPORTS_LIMIT,
  SCENARIO_PROGRESS_METRIC_KEYS,
  SCENARIO_PROGRESS_METRIC_LABEL,
  SCENARIO_SEED_QUEST_ORIGIN,
  SCENARIO_TARGET_TOTAL_VIEWS_MAX,
  SCENARIO_TEMPLATE_CREATOR_COUNT_MAX,
  SCENARIO_TEMPLATE_CREATOR_COUNT_MIN,
  SCENARIO_TEMPLATE_DURATION_DAYS_MIN,
  SCENARIO_TEMPLATE_TARGET_REGION_MAX,
  SERVER_TELEMETRY_EVENT_NAMES,
  SETTINGS_ERROR_CODES,
  SETTLEMENT_AMOUNT_PATTERN,
  SETTLEMENT_APPROVAL_CLEARANCE_TRANSITION,
  SETTLEMENT_APPROVAL_THRESHOLD_CURRENCY,
  SETTLEMENT_APPROVAL_THRESHOLD_USD,
  SETTLEMENT_CURRENCY_PATTERN,
  SETTLEMENT_DOMESTIC_CURRENCY,
  SETTLEMENT_KINDS,
  SETTLEMENT_KIND_ACCOUNTING_DEFAULTS,
  SETTLEMENT_MARKABLE_STATUSES,
  SETTLEMENT_NOTIFICATION_HOURS,
  SETTLEMENT_NOTIFICATION_TYPES,
  SETTLEMENT_REASON_REQUIRED_STATUSES,
  SETTLEMENT_REQUESTABLE_KINDS,
  SETTLEMENT_REQUEST_MAX_ENTRIES,
  SETTLEMENT_STATUS_TRANSITIONS,
  SHORT_LINK_ALIAS_PATTERN,
  SHORT_LINK_PREVIEW_BOT_PATTERN,
  SHORT_LINK_RESERVED_ALIASES,
  SPEND_IDLE_GRACE_DAYS_DEFAULT,
  SPEND_RATE_HIGH_FLAG_DEFAULT,
  SPEND_RATE_LOW_FLAG_DEFAULT,
  STIBEE_MAX_RETRIES,
  STIBEE_RETRY_DELAY_MS,
  SUPPORTED_VIDEO_MIME_TYPES,
  SYSTEM_ACTOR_USER_ID,
  SYSTEM_ACTOR_USER_SEED,
  SYSTEM_TIMELINE_EVENT_TYPES,
  ScenarioCampaignType,
  ScenarioContentDeliveryIssueReason,
  ScenarioContractTargetRevisionStatus,
  ScenarioDropSignalStatus,
  ScenarioOperationalHealthLabel,
  ScenarioOperationalIssueArea,
  ScenarioOperationalIssueReportStatus,
  ScenarioOperationalSignalGapDirection,
  ScenarioProgressBlockerCode,
  ScenarioProgressCompletionState,
  ScenarioProgressMetricKey,
  ScenarioRecruitingIssueReason,
  ScenarioReferenceSchema,
  ScenarioReviewMode,
  ScenarioStatus,
  ScheduleType,
  SearchKnowledgeQuerySchema,
  SegmentSourceType,
  SegmentType,
  SettlementApprovalUndeterminedReason,
  SettlementApprovalVerdict,
  SettlementCostBearer,
  SettlementKind,
  SettlementPayoutForm,
  SettlementPayoutMethod,
  SettlementStatus,
  StopRuleDirection,
  StopRuleMetric,
  StopRuleVerdict,
  TAX_INCOME_BULK_MAX,
  TEAM_ERROR_CODES,
  TEAM_SCHEDULE_MAX_DAYS,
  TELEMETRY_EVENT_NAMES,
  TELEMETRY_EVENT_RETENTION_DAYS,
  TERMINAL_CHECKPOINT_STATUSES,
  TIMELINE_EVENT_TYPE_DISPLAY_LABEL,
  TIMELINE_EVENT_TYPE_LABEL,
  TOUCH_HISTORY_TYPES,
  TRACKING_IMPORT_APPLIED,
  TRIAGER_ONLY_STATUSES,
  TargetSlotState,
  TaskForceMetadataSchema,
  TeamCapability,
  TeamMetadataSchema,
  TeamRole,
  TeamRolePermissionModifiers,
  TeamStatus,
  TeamType,
  TimelineAttachmentType,
  TimelineEventType,
  TokenType,
  TrackingImportResult,
  UNCLAIMED_CLOSE_REASONS,
  UNPAGINATED_LIST_CAP,
  UPLOAD_ERROR_CODES,
  USAGE_DASHBOARD_DEFAULT_DAYS,
  USAGE_DASHBOARD_MAX_DAYS,
  USAGE_DENOMINATOR_NOTE,
  USAGE_TELEMETRY_CAVEATS,
  USERNAME_MAX_LENGTH,
  USERNAME_MIN_LENGTH,
  USERNAME_PATTERN,
  USER_ERROR_CODES,
  USER_STATUS_LABELS,
  UpdateKnowledgeSourceSchema,
  UserLevel,
  UserRole,
  UserStatus,
  UsernameSchema,
  VIDEO_POST_PLATFORM_LABEL,
  VIDEO_RIGHT_AXES,
  VIDEO_RIGHT_AXIS_LABEL,
  VIDEO_RIGHT_VALUES,
  VIDEO_RIGHT_VALUE_LABEL,
  VIDEO_TRACKING_ERROR_MESSAGES,
  VIDEO_TRACKING_INBOX_REASONS,
  VIDEO_TRACKING_SUCCEEDED_END_REASONS,
  VIEW_API_PERMISSION,
  VIEW_ELIGIBILITIES,
  VIEW_METRICS_COVERAGE,
  VIEW_METRICS_DISPLAY_STATES,
  VIEW_METRICS_FRESHNESS,
  VIEW_METRICS_LAST_COLLECTION,
  VIEW_METRICS_REFRESH_STATES,
  VIEW_METRICS_SAMPLE_STATUS,
  VIEW_METRICS_SNAPSHOT_CAPTURED_ON,
  VIEW_METRICS_SNAPSHOT_OUTCOMES,
  VIEW_METRICS_UNAVAILABLE_REASONS,
  VideoPostPlatform,
  VideoPostRole,
  VideoPostStatus,
  VideoRightAxis,
  VideoRightValue,
  WARM_POOL_BASES,
  WARM_POOL_STATES,
  WEEKDAYS,
  WIKI_AREAS,
  WIKI_AREA_LABELS,
  WIKI_AREA_SEEDS,
  WIKI_BODY_MAX,
  WIKI_COMMENT_MAX,
  WIKI_DISCUSSION_STATUSES,
  WIKI_DISCUSSION_TITLE_MAX,
  WIKI_DOCUMENT_KINDS,
  WIKI_ERROR_CODES,
  WIKI_HOME_TITLE,
  WIKI_IMAGE_BUCKET,
  WIKI_IMAGE_MIME_TYPES,
  WIKI_PAGE_TITLE_PREFIX,
  WIKI_REVISION_KINDS,
  WIKI_SYSTEM_AREA_KEYS,
  WIKI_TITLE_MAX,
  WORKLOG_ERROR_CODES,
  WORK_DAY_CUTOFF_HOUR,
  WorkLogStatus,
  WorkType,
  acceptQuest,
  acceptQuestSchema,
  acceptanceScenarioRefSchema,
  activateScenario,
  adcodeIssueWarning,
  addAttachmentSchema,
  addDependency,
  addMember,
  addMemberSchema,
  addQuestDependencySchema,
  adjustBalanceSchema,
  adjustPointsSchema,
  adminCancelLeaveSchema,
  advertiserBrandBodySchema,
  advertiserContactSchema,
  alignCampaignPeriod,
  allowedBoostingTransitions,
  applyAdminEdit,
  applyCorrection,
  applyCropEdit,
  applyFeatureFlagOverrides,
  applySegmentTypeCorrection,
  applyTargetSlotAction,
  approveActivity,
  approveCheckpointSchema,
  approveCorrectionSchema,
  approveFeed,
  approveFeedCapExceededSchema,
  approveFeedResponseSchema,
  approvePieceworkSchema,
  approveProof,
  approveProofSchema,
  approveQuest,
  approveQuestSchema,
  approveSubmission,
  approvedOriginalSourceLabel,
  archiveActivity,
  archiveQuest,
  archiveScenario,
  archiveTeam,
  assembleHeroPoll,
  assertAdvertiserUsable,
  assertBoostingTransition,
  assertCanDeleteCheckpoint,
  assertCanSubmit,
  assertRelationStateChange,
  assertRuleWellFormed,
  assertSettlementTransition,
  assertStatus,
  assertThreadBody,
  assessOriginalIntegrity,
  assessVideoRetention,
  assignCampaignTargetSlotSchema,
  assignCheckpoint,
  assignCheckpointSchema,
  assignCreatorRelationOwnerSchema,
  assigneeAfterSend,
  attachmentDownloadName,
  authenticateSchema,
  autoSubmitCheckpointProofSchema,
  autoSubmitQuestProofSchema,
  awaitingLeaderReply,
  backfillLinearDependencies,
  batchRegisterSchema,
  batchRegisterUserSchema,
  batchReviewOffDaySchema,
  blockCreatorRelationSchema,
  budgetCarryover,
  budgetPoolKey,
  budgetProjectedRemaining,
  budgetRemaining,
  budgetVariance,
  budgetVarianceRate,
  buildConditionChangeTargets,
  buildCursorResponse,
  buildDeepLinkQuery,
  buildScheduleRevisions,
  buildSystemActorUpsertArgs,
  buildTemplateUsagePayload,
  bulkArchiveQuestsResponseSchema,
  bulkArchiveQuestsSchema,
  bulkCreateCampaignRosterVideoRightSchema,
  bulkMarkCampaignSettlementStatusSchema,
  bulkVoidPayoutResponseSchema,
  bulkVoidPayoutSchema,
  bulkVoidPayoutSkippedSchema,
  calculateAnnualLeaveEntitlement,
  calculateCampaignPrice,
  calculateClubDuration,
  calculateCurrentWorkDuration,
  calculateDroppedSignals,
  calculateGaugeProgress,
  calculateInternConversionDate,
  calculateInternConversionDday,
  calculateLeadTime,
  calculateManagerBonus,
  calculateOpenReplacementSignals,
  calculateScenarioContractTargetRevisionSlots,
  calculateScenarioViewProgress,
  calculateServicePeriod,
  calculateStalenessPercent,
  calculateTotalWorkDuration,
  campaignAdcodeDryRunRowSchema,
  campaignAdcodeDryRunSchema,
  campaignAdcodeImportSchema,
  campaignPeriod,
  campaignPeriodEnd,
  campaignRetroDueAt,
  campaignRetroListQuerySchema,
  campaignRosterImportRowSchema,
  campaignRosterImportSchema,
  campaignRosterProfileLinkResolveSchema,
  campaignTargetSlotSchema,
  campaignTimelineEntrySchema,
  campaignTimelineSaveSchema,
  campaignVideoTrackingMetricsSchema,
  campaignZeroReasonOf,
  canAccessView,
  canAccessViewFull,
  canArchiveScenario,
  canCommentOnAdcodeRequest,
  canCommentOnOperationalIssueReport,
  canCommentOnQuestQuestion,
  canCommentOnQuestTaskFeedback,
  canConfirmCampaignPerformanceReport,
  canDeleteCheckpoint,
  canEditReplyTemplate,
  canExportCreators,
  canExportRosterShipping,
  canMarkRosterDraftArrival,
  canModifyCheckpoint,
  canNudgeRosterRow,
  canOpenWindowDuringOnboarding,
  canPerform,
  canPromoteToTeamTemplate,
  canReadReplyTemplate,
  canRequestResubmit,
  canRerequestRosterRevision,
  canRestoreRosterDrop,
  canReviewAdcodeProof,
  canReviewCreatorMatching,
  canReviewProof,
  canSaveCampaignDefault,
  canSearchCreatorsCompanyWide,
  canTransitionCheckpoint,
  canTransitionQuest,
  canTransitionSettlement,
  canTransitionTo,
  canViewCreator,
  canViewUsageDashboard,
  canWriteQuestQuestion,
  canWriteQuestTaskFeedback,
  cancelActionFor,
  cancelCampaignTargetSlotSchema,
  cancelCampaignVideoReviewRevisionSchema,
  cancelProof,
  captureInitialCreatorsRecruitedAt,
  cardSections,
  challengeCandidateSchema,
  changeAdvertiserReviewModeSchema,
  changeCreatorRelationStateSchema,
  changePasswordSchema,
  checkClubDurationCap,
  checkExtraPostUrl,
  checkQuestProductAttachment,
  checkoutQuestTask,
  checkpointTransitionSourcesTo,
  childrenOf,
  classifyArchiveGap,
  classifyArchiveMessage,
  classifyConditionChange,
  classifyExpiredAttribution,
  classifyOriginalRecovery,
  classifySpendAnomaly,
  classifyStibeeFailure,
  classifyWorkSegments,
  clientTelemetryEventNameSchema,
  clockIn,
  clockInSchema,
  clockOut,
  clockOutSchema,
  cloneReplyTemplate,
  closeAllOpenSegments,
  closeDaySchema,
  closeMissedAttendance,
  closeSegment,
  clubCodePrefix,
  clubDDay,
  clubDateLabel,
  clubDeadlineLabel,
  clubTransferLeadershipSchema,
  compareCheckpointOrder,
  compareReplyUrgency,
  completeAcceptances,
  completeCheckpoint,
  completeQuest,
  completeQuestTask,
  completeQuestTaskSchema,
  completeScenario,
  computeAttendanceAggregate,
  computeCheckpointFillValue,
  computeCycleKey,
  computeDistribution,
  computeNextCycle,
  computeQuestProgress,
  computeSegmentedGrossPay,
  computeSettlementWithholding,
  computeTeamAggregate,
  computeWorldQuestLane,
  confirmCreatorResolutionSchema,
  confirmPerformanceReportSchema,
  confirmPoll,
  confirmPollSchema,
  confirmedSubsumeWorks,
  contextNodes,
  convertBugReportToQuestSchema,
  countDraftReviewRounds,
  countPendingGroups,
  countWeekdays,
  createActivity,
  createAdcodeCommentSchema,
  createAdvertiser,
  createAdvertiserSchema,
  createAgentSchema,
  createApprovedOriginalUploadSchema,
  createAttendanceSchema,
  createBugReportSchema,
  createCampaignRetroObservationSchema,
  createCampaignRosterDropRestoreSchema,
  createCampaignRosterDropSchema,
  createCampaignRosterEntrySchema,
  createCampaignRosterExtraPostSchema,
  createCampaignRosterManualCommunicationSchema,
  createCampaignRosterPriceRevisionSchema,
  createCampaignRosterScheduleRevisionSchema,
  createCampaignRosterSnapshotRevisionSchema,
  createCampaignRosterUploadTakedownSchema,
  createCampaignRosterVideoRightSchema,
  createCampaignSettlementRequestSchema,
  createCampaignVideoReviewRevisionSchema,
  createCampaignVideoReviewUploadSessionSchema,
  createChannelGroupSchema,
  createChannelSchema,
  createCheckpoint,
  createCheckpointSchema,
  createClub,
  createClubSchema,
  createCompensationSchema,
  createConditionAgreementSchema,
  createConversationSchema,
  createCorrectionSchema,
  createCreatorNotepadEntrySchema,
  createCreatorRelationNoteSchema,
  createCreatorRelationSchema,
  createDayScheduleSchema,
  createDepartment,
  createDepartmentSchema,
  createDraftContentFromTemplate,
  createDropSignalSchema,
  createEventSchema,
  createFeedSchema,
  createHolidaySchema,
  createIsHolidayFn,
  createLeaveRequestSchema,
  createMcpTokenSchema,
  createOperationalIssueReportSchema,
  createOperationalReportCommentSchema,
  createPageViewSchema,
  createPermission,
  createPieceworkActivitySchema,
  createPollSchema,
  createProduct,
  createProductSchema,
  createProof,
  createProofSchema,
  createQuest,
  createQuestAttachmentSchema,
  createQuestBaseSchema,
  createQuestProposalSchema,
  createQuestQuestion,
  createQuestQuestionComment,
  createQuestQuestionCommentSchema,
  createQuestQuestionSchema,
  createQuestSchema,
  createQuestTask,
  createQuestTaskFeedback,
  createQuestTaskFeedbackComment,
  createQuestTaskFeedbackCommentSchema,
  createQuestTaskFeedbackSchema,
  createQuestTaskSchema,
  createQuestTemplate,
  createQuestTemplateSchema,
  createReplyTemplateSchema,
  createReservationSchema,
  createRoomSchema,
  createRosterStatusValidator,
  createScenario,
  createScenarioOperationalIssueReportComment,
  createScenarioProduct,
  createScenarioProductSchema,
  createScenarioSchema,
  createScenarioTemplate,
  createScenarioTemplateSchema,
  createSegment,
  createSegmentCorrectionSchema,
  createSelectionGuidelineSchema,
  createSettlementCurrencyValidator,
  createShortLinkSchema,
  createSignedUploadUrlSchema,
  createTargetSlotSnapshot,
  createTaskForce,
  createTaskForceSchema,
  createTelemetryEventSchema,
  createTelemetryObservationQuestionSchema,
  createTelemetryObservationReviewSchema,
  createTemplateCheckpointSchema,
  createTimelineEventSchema,
  createWikiAreaSchema,
  createWikiDiscussionCommentSchema,
  createWikiDiscussionSchema,
  createWikiDocumentSchema,
  createWikiImageUploadSchema,
  createWorkLog,
  createWorkLogSchema,
  creatorCampaignPriceSchema,
  creatorEmailSchema,
  creatorListBuildSchema,
  creatorListDownloadPath,
  creatorListQueryRequestSchema,
  creatorMailDraftHistory,
  creatorMailDraftLeaseExpiry,
  creatorMailThreadRevisionSchema,
  creatorNotepadEntryResponseSchema,
  creatorRelationCardSchema,
  creatorRelationCardSectionsSchema,
  creatorRelationHistoryCursorSchema,
  creatorRelationHistoryItemSchema,
  creatorRelationHistoryPageSchema,
  creatorRelationIntimacyMeasureSchema,
  creatorRelationListCursorSchema,
  creatorRelationListItemSchema,
  creatorRelationListQuerySchema,
  creatorRelationListResponseSchema,
  creatorRelationListViewerSchema,
  creatorRelationOtherTeamContactSchema,
  creatorRelationOtherTeamContactsQuerySchema,
  creatorRelationOtherTeamContactsResponseSchema,
  creatorRelationPersonSchema,
  creatorRelationPiiSchema,
  creatorRelationQueueResponseSchema,
  creatorRelationRefSchema,
  creatorRelationRegionSchema,
  creatorRelationRegionsResponseSchema,
  creatorRelationSummaryQuerySchema,
  creatorRelationSummaryResponseSchema,
  creatorRelationTimelineQuerySchema,
  creatorViewMetricsQuerySchema,
  creditedActorOf,
  currentOwnerUserId,
  currentVideoRights,
  datetimeLocalToKstISO,
  dayScheduleContentSchema,
  dayScheduleDateSchema,
  dayScheduleMonthSchema,
  dayScheduleSharedTeamSchema,
  daysSinceInvestment,
  decidePieceworkActivitySchema,
  declareProductPosture,
  defaultCampaignTimeline,
  defaultOutreachTimeZone,
  deleteQuest,
  deleteQuestTask,
  deltaFromCumulative,
  deriveAdvertiserReviewMark,
  deriveAnchorCountsFromOutreachRounds,
  deriveAnchorCountsFromRoster,
  deriveBlockedUntil,
  deriveBoostingStage,
  deriveCampaignDifficulty,
  deriveCampaignRetroPermissions,
  deriveCampaignType,
  deriveCandidateContact,
  deriveClockTimesFromSegments,
  deriveEffectiveRosterSnapshot,
  deriveGuidelineDrafts,
  deriveImportRosterStage,
  deriveOperationalSignalGap,
  deriveOutreachBlockedAt,
  deriveOutreachFormWatch,
  deriveOutreachFunnel,
  deriveQuestDraftFromEvent,
  deriveRecruitRemaining,
  deriveRecruitmentPolicy,
  deriveRelationState,
  deriveRosterBallHolder,
  deriveRosterContentReviewDisplay,
  deriveRosterPhase,
  deriveRosterShippingState,
  deriveRosterStallSignal,
  deriveScenarioProcedureProgress,
  deriveScenarioProcedureProgressFromSignals,
  deriveTargetSlotCounts,
  deriveViewMetricsDisplayState,
  deriveWarmPoolSummary,
  deriveWikiKind,
  descendantIds,
  describeAdvertiserReviewRound,
  describeQuestChain,
  detectMissedClockOut,
  detectMultiRecord,
  detectSingleRecord,
  detectVideoPostPlatform,
  discovererUserId,
  distributeDividend,
  distributionKindSchema,
  dividendGrantNote,
  dividendPool,
  dokkaebiSignalSchema,
  dropAcceptance,
  editAttendanceSchema,
  editBugReportSchema,
  editMessageSchema,
  effectiveRelationHistory,
  effectiveTaskValue,
  elapsedDays,
  endBreak,
  ensureSystemActor,
  escapeOutreachHtml,
  evaluateBlock,
  evaluateOutreachUnblock,
  evaluateRelationStateChange,
  evaluateTargetSlotConditions,
  evaluateUnblock,
  exceedsDailyMax,
  exclusionLockAt,
  expiryCloseQuestSchema,
  extractWikiSection,
  failAcceptances,
  failQuest,
  failScenario,
  featureFlags,
  feedAttachmentInputSchema,
  fetchAllCursorPages,
  findAggregateAttendancesSchema,
  findBlockedByAbsorbedPredecessor,
  findPricedQuestsWithoutPromisedDeadline,
  findQuestsMissingBudgetLedger,
  findRosterImportDuplicateKeys,
  findUnknownTemplateVariables,
  floorRelationState,
  forceCloseAttendance,
  forfeitCheckpoint,
  forfeitCheckpointsOnQuestFail,
  formEntryKeyOf,
  formatAdcodeQuestCreatedBody,
  formatAdcodeRequestedAt,
  formatCheckpointSubmittedBody,
  formatDateDotKo,
  formatDateKo,
  formatDuration,
  formatDurationCompact,
  formatDurationKo,
  formatElapsed,
  formatIsoCountryDisplay,
  formatKstDateTime,
  formatKstTime,
  formatLocalDateTimeInput,
  formatMonthDayKo,
  formatMs,
  formatNotificationRelativeTime,
  formatOpenCallRevokedBody,
  formatOpsSignalCommentAddedBody,
  formatOpsSignalHelpNeededBody,
  formatOpsSignalReportCreatedBody,
  formatOpsSignalStatusChangedBody,
  formatOutreachAmount,
  formatOutreachDate,
  formatOvertimeHours,
  formatKstMinute as formatPerformanceReportMinute,
  formatPerformanceReportNotionTable,
  formatViews as formatPerformanceReportViews,
  formatPricingGround,
  formatQuestApprovedBody,
  formatQuestDeletedBody,
  formatQuestPrerequisitesMetBody,
  formatQuestProofSubmitReminderBody,
  formatQuestProofSubmittedBody,
  formatQuestProposalAdoptedBody,
  formatQuestProposalCreatedBody,
  formatQuestProposalDeclinedBody,
  formatQuestPublishedBody,
  formatQuestQuestionCreatedBody,
  formatQuestRejectedBody,
  formatQuestTaskAttachmentAddedBody,
  formatQuestTaskFeedbackAddedBody,
  formatQuestUpdatedBody,
  formatRosterDropEvent,
  formatScenarioCode,
  formatScenarioProgressOwnerAssignedBody,
  formatScenarioProgressOwnerRevokedBody,
  formatScheduledLocal,
  formatTimeShort,
  formatUsageRatioPct,
  formatWorklogNotSubmittedBody,
  gateWeight,
  gateWeightShares,
  gateWeightSnapshot,
  generateClubCode,
  generateHolidaySchedulesSchema,
  getAccessibleViews,
  getActiveParticipantCount,
  getAllAccessibleViews,
  getAppViewLabel,
  getAppViewMeta,
  getBusinessDaysUpToToday,
  getCapabilityViews,
  getIsoCountryNameKo,
  getKstDateAfterDays,
  getKstDateString,
  getKstDayRange,
  getKstMonthDay,
  getKstMonthRange,
  getKstMonthStart,
  getKstPeriod,
  getKstWeekStart,
  getKstWorkDayLastInstant,
  getKstWorkDayRange,
  getLeader,
  getLedgerPeriod,
  getLocalDateString,
  getLocalMonthStart,
  getLocalStartOfDay,
  getLocalToday,
  getLocalWeekStart,
  getMembers,
  getMobileNotificationRoute,
  getPayPeriod,
  getPayPeriodByKey,
  getPayPeriodUtcWindow,
  getPermissionsForUser,
  getQuestAcceptanceBlockedReason,
  getSettlementSchedule,
  getStageProofGuide,
  getViewState,
  getWikiDocumentQuerySchema,
  grantLeaveSchema,
  grantPointsSchema,
  groupPrerequisites,
  guidelineDeliveryCandidates,
  guidelineReviewRequirementSchema,
  guidelineReviewRequirementsSchema,
  hangulInitials,
  hasActionMarker,
  hasAdcodeCommentThread,
  hasDraftAwaitingReview,
  hasEmailOrTicket,
  hasLostAllTargets,
  hasLostSomeTargets,
  hasNoReplyMarker,
  hasOwnSectionNumbers,
  hasPermission,
  hasPostureMismatch,
  hasTombstoneHistory,
  hashToAvatarTint,
  identifyByNameSchema,
  identifySchema,
  idleDays,
  importRosterStageAdvance,
  initializeCampaignTargetSlotsSchema,
  instantiateQuest,
  instantiateQuestSchema,
  instantiateTemplate,
  instantiateTemplateSchema,
  inviteMemberSchema,
  isActionFlowNode,
  isAdvertiserReviewMode,
  isAdvertiserReviewPending,
  isAdvertiserReviewVerdict,
  isAdvertiserRoundFree,
  isAllowedCropAspectRatio,
  isAppView,
  isArchiveCopyMissing,
  isAutoFillTask,
  isAutomatedArchiveReply,
  isBalanceDeductible,
  isBlockActive,
  isBlockReasonKind,
  isBudgetLedgerActive,
  isBudgetLedgerClosed,
  isCampaignAdCode,
  isCancelConfirmed,
  isCapabilityView,
  isCeo,
  isCeoPolicyKey,
  isChainOpen,
  isCheckpointClosed,
  isCheckpointLockExpired,
  isCheckpointRejectReasonKind,
  isConditionAgreed,
  isCreatorMailDraftLeaseAlive,
  isCreatorPricePlatform,
  isCreatorResendOpen,
  isCurrentVideoTracking,
  isDefaultExcluded,
  isDefaultExcludedContact,
  isDepartedUserStatus,
  isDraftReviewRoundAtRisk,
  isExcludedFromTeamAverage,
  isExportUploadConfirmed,
  isFeatureActive,
  isForwardRosterStageTransition,
  isGuidelineDeliveryCheckpoint,
  isHolidayForDate,
  isInContext,
  isInitialsQuery,
  isInvestmentStale,
  isIso4217AlphaCode,
  isLeaderboardPeriod,
  isLeaveType,
  isLinkedChainOpen,
  isManagerBonusEligibleRow,
  isManualRosterDropKind,
  isMcpScope,
  isNotificationAllowed,
  isNotificationOptInTopic,
  isNotificationScope,
  isNotificationType,
  isOccurredAtAcceptable,
  isOffDayForDate,
  isOnboardingIsolated,
  isOnboardingQuestHiddenFor,
  isOurTurn,
  isOutreachSuppressionReason,
  isOwnerEligible,
  isParticipantInAudience,
  isPastDate,
  isPipelineStale,
  isProofReviewOverdue,
  isQuestAcceptanceBlockedByCheckpoints,
  isQuestChainCleared,
  isQuestExpired,
  isReRecruitReasonKind,
  isReachableQuestState,
  isReasonValidForArea,
  isRelationState,
  isReplyDeadlineAtRisk,
  isReplyNeglected,
  isRequestableSettlementKind,
  isResolvedQuestProposalStatus,
  isRestrictedCreator,
  isRosterContentReview,
  isRosterCreatorOperable,
  isRosterDropEventAction,
  isRosterDropKind,
  isRosterScheduleKind,
  isRosterTakedownRequester,
  isRosterUploadComplete,
  isRoundLocked,
  isSameDayTitleFix,
  isSameInstantWithinTolerance,
  isSamePool,
  isScenarioSeedQuest,
  isSealedWorldQuestKind,
  isSendStarted,
  isSettlementAmount,
  isSettlementCostBearer,
  isSettlementKind,
  isSettlementNotificationType,
  isSettlementPayoutForm,
  isSettlementPayoutMethod,
  isSettlementStatus,
  isSettlementTermAllowedFor,
  isShortLinkTargetAllowed,
  isTargetSlotState,
  isTikTokUrl,
  isTiktokNumericId,
  isUnblockedBy,
  isUnclaimedCloseReason,
  isUnwrittenOutreachDraft,
  isValidCheckpointType,
  isValidDateOnly,
  isValidIsoCountry,
  isValidOutreachFormUrl,
  isValidTargetSlotSnapshot,
  isVideoRightAxis,
  isVideoRightValue,
  isViewMetricsSampleInsufficient,
  isVoteEligible,
  isWikiImageFile,
  isWikiPageTitle,
  isWritableRosterStatus,
  isoWeekKey,
  isoWeekRange,
  issueCampaignAdcodeSchema,
  judgeCampaignVideoReviewRevisionSchema,
  judgeRewardByPricing,
  judgeSettlementApproval,
  judgeStopRule,
  judgeTeamRetention,
  kickMemberSchema,
  kstDate,
  kstDateToInstant,
  kstStartOfDay,
  lastTouchAt,
  latestScheduleByKind,
  listContentPosts,
  listQuestProposalsQuerySchema,
  listReservationsQuerySchema,
  listReservationsRangeQuerySchema,
  listShortLinksSchema,
  listWikiDiscussionsQuerySchema,
  listWikiDocumentsQuerySchema,
  lockActivity,
  loginSchema,
  managerBonusAllocationOf,
  managerBonusListQuerySchema,
  managerBonusRowCountsSchema,
  mapFormResponses,
  mapRawAdcodeRow,
  mapRawRosterRow,
  markCampaignSettlementStatusSchema,
  markPaidSchema,
  markSettlementDocumentsSchema,
  maskPayoutValue,
  matchBulkReply,
  matchHangul,
  mcpScopeSchema,
  memoryImageTint,
  mergeAdvertiserSchema,
  mergeFromDraftSchema,
  messagesToGraph,
  missingRequiredRosterKeys,
  missingRosterDeliveryConditions,
  moveChannelToGroupSchema,
  myShareReasonOf,
  needsActualValue,
  nextContractVideoNo,
  nextKstPeriod,
  nextReservationConfirmStep,
  normalizeAdcodeLabel,
  normalizeAdvertiserName,
  normalizeAdvertiserReviewModeInitialReason,
  normalizeCreatorHandle,
  normalizeDeadline,
  normalizeGuidelineUrl,
  normalizeRosterLabel,
  normalizeShippingCarrier,
  normalizeSuppressionEmail,
  normalizeTrackingNumber,
  normalizeVideoUrl,
  normalizeWikiTitle,
  notSettledReasonOf,
  oauthConsentApproveSchema,
  oauthConsentDenySchema,
  onboardingQuestVisibilityWhere,
  openAdvertiserReviewRoundSchema,
  orderRosterForExport,
  outreachBlockCreatorRelationSchema,
  outreachBulkReserveSchema,
  outreachBulkSendSchema,
  outreachDraftContentSchema,
  outreachDraftCtaSchema,
  outreachFormRespondUrl,
  outreachHandleEntryKeys,
  outreachOutlierRowsRequestSchema,
  outreachOutlierSummaryRequestSchema,
  outreachPresenceLeaseExpiry,
  outreachProductName,
  outreachTestSendSchema,
  outreachUnblockCreatorRelationSchema,
  ownerRevocationCause,
  ownerScopeMeasures,
  parseAspectRatio,
  parseDeepLinkFromQuery,
  parseFromAddress,
  parseLeaveType,
  parseOutreachFormUrl,
  parsePayoutInput,
  parsePriorityBasis,
  parseSeedingTeamIds,
  parseStopRule,
  parseTiktokVideoLink,
  parseWikiLinks,
  parseWikiRedirect,
  passkeyLoginOptionsSchema,
  passkeyLoginVerifySchema,
  payPeriodElapsedDays,
  payoutVoidReasonSchema,
  paypalMeSchema,
  pendingSubsumeWorks,
  performanceReportPrintHeader,
  statusLabel as performanceReportStatusLabel,
  videoRemark as performanceReportVideoRemark,
  periodSummaryQuerySchema,
  permissionsFromScopes,
  pickRepresentativeAdcodePerVideo,
  planAdditionalContractVideo,
  planApprovedOriginalWrite,
  planBoostingBackfill,
  planBoostingBackfillPath,
  planRoundExclusions,
  planTrackingImport,
  pointsToKrw,
  previousKstPeriod,
  pricingGroundSchema,
  pricingNeedsReasonCode,
  priorContribution,
  productPostureSchema,
  productSubsumeWorkInputSchema,
  productTargetInputSchema,
  projectedSpendRate,
  proofAttachmentSchema,
  proofFailureStageSchema,
  proofSubmissionPathSchema,
  prunePunchQueue,
  qualifiesForFlexWeeklyWork,
  queryAuditLogsSchema,
  queryPageViewStatsSchema,
  queryProofSubmissionStatsSchema,
  queryQuestCreationStatsSchema,
  queryTelemetryEventStatsSchema,
  queryTelemetryObservationQuestionsSchema,
  questDependencyHistoryQuerySchema,
  questDependencyReasonSchema,
  questDifficultyToRarity,
  questDifficultyWeight,
  questDistributionKindSchema,
  questStateOf,
  questStatusToFeStatus,
  questStatusToFeStatusOrPending,
  questTaskTitleError,
  questTransitionSourcesTo,
  readCompanyDifficultyRanges,
  readCreatorMailDraftTakeovers,
  readPollingSilence,
  readPostAccess,
  readResumePoint,
  readTrackingSheet,
  realtimeTokenResponseSchema,
  reassignCampaignRosterAssigneeSchema,
  reassignSegmentSchema,
  recalculateLockStates,
  recentWikiChangesQuerySchema,
  recommendRegular,
  recommendedTeamBudget,
  recordAdvertiserReviewVerdictsSchema,
  recordCampaignReportSchema,
  recordOffRosterContactSchema,
  registerSchema,
  registerVerifySchema,
  regularParamsAt,
  rejectActivityCreation,
  rejectAdcodeRequestSchema,
  rejectCheckpointSchema,
  rejectProof,
  rejectProofSchema,
  rejectQuest,
  rejectQuestSchema,
  rejectSubmission,
  relationStateRank,
  releaseCheckpoint,
  releaseCheckpointsOnDrop,
  relinkRosterCreatorSchema,
  remainingAfterTask,
  removeMember,
  renamePasskeySchema,
  renderOutreachDraftHtml,
  renderReplyTemplate,
  reorderCheckpointsSchema,
  reorderQuests,
  reorderQuestsSchema,
  replaceWikiSection,
  representativeImageSchema,
  requestAdcodeSchema,
  requestProofResubmitSchema,
  requestRosterCreatorCollectionSchema,
  requestVaSchema,
  requiredRosterKeyLabel,
  requiresAdvertiserApproval,
  requiresExecutiveApproval,
  requiresSettlementClearanceReason,
  reservationGuardAtLock,
  resetFeatureFlags,
  resetPasswordSchema,
  resolveAppliedConditions,
  resolveCompensationAt,
  resolveDifficultyPricing,
  resolveFormQuestionIds,
  resolveLeaveApprovalAuthority,
  resolveMissedClockInSchema,
  resolveMissedClockOutSchema,
  resolveProofGateOwners,
  resolveQualitativeGateOwners,
  resolveQuestProposalSchema,
  resolveReplyDeadline,
  resolveRosterDraftReceivedAt,
  resolveScheduledInstant,
  resolveStaleTaskSchema,
  resolveTargetSlotRequirements,
  resolveWikiArea,
  restoreTeam,
  resubmitCorrectionSchema,
  resubmitProof,
  resumeAttendance,
  retentionBusinessDate,
  retentionStartOf,
  retentionWindow,
  revertWikiDocumentSchema,
  reviewCorrectionSchema,
  reviewFileIntegrityAction,
  reviewLeaveRequestSchema,
  reviewOffDaySchema,
  reviewQuestQuestionReplies,
  revisedAfterLogDay,
  revokeAllSessionsSchema,
  revokeWorldQuest,
  revokeWorldQuestSchema,
  rosterDeliveryBlock,
  rosterFormEventAt,
  rosterImportMatchKey,
  rosterManualCommunicationChannelSchema,
  rosterManualCommunicationEventTypeSchema,
  rosterManualCommunicationStatsQuerySchema,
  rosterManualCommunicationTargetRoleSchema,
  rosterPayoutWriteSchema,
  rosterPriceCurrency,
  rosterScheduleConfirmInputSchema,
  rosterScheduleView,
  rosterWritableStatusValidator,
  saveAsTemplateSchema,
  saveCreatorMailDraftSchema,
  saveOutreachDraftSchema,
  saveOutreachSelectionSchema,
  scenarioAcceptancePanelSchema,
  scenarioAcceptanceRowSchema,
  scenarioTemplateQuestItemSchema,
  scheduleConfirmationState,
  scoreOf,
  searchCreatorProjectionsSchema,
  searchWikiQuerySchema,
  seedCheckpointDiscriminator,
  seedEventTypeForRosterStage,
  segmentEditItemSchema,
  selectApprovedOriginalFile,
  selectConversationMessages,
  selectProofReminderTargets,
  selectionGuidelineQuerySchema,
  sendAssistantMessageSchema,
  sendCreatorMailSchema,
  sendMessageAttachmentSchema,
  sendMessageSchema,
  sendOtpSchema,
  serializeContext,
  setAdvertiserActive,
  setChannelNotifyLevelSchema,
  settlementQueueQuerySchema,
  shareUnpaidReasonOf,
  shortLinkSchemas,
  shortLinkSubjectKeySchema,
  shouldIngestFormResponses,
  snapshotConditionsForWrite,
  sortRelationHistory,
  spendRate,
  splitKakaoChannelName,
  splitLeaveDaysByServiceYear,
  splitQuestState,
  splitWikiSections,
  startBreak,
  startCreatorMailConnectionSchema,
  stibeeReserveTime,
  stibeeRetryDecision,
  stopRuleSchema,
  stripCreatorHandlePrefix,
  stripMarkers,
  strongerSuppression,
  submitForApproval,
  submitPiecework,
  submitPieceworkSchema,
  submitProof,
  submitProofSchema,
  submitQuestProof,
  submitWorkLog,
  sumSegmentMs,
  summarizeCampaignPerformance,
  summarizeConditionChange,
  summarizeCreatorPosts,
  summarizeDomesticQueue,
  summarizePointTeamAttribution,
  summarizeRosterDraftEvents,
  summarizeRosterNudges,
  summarizeScenarioOperationalHealth,
  suppressionOfPerson,
  syncHolidaysSchema,
  syncSegmentBoundaries,
  tagQuestToScenario,
  takeOverCreatorMailDraftSchema,
  targetSlotAssignmentSchema,
  targetSlotCandidatesQuerySchema,
  targetSlotChangedEventSchema,
  targetSlotDeliverySchema,
  targetSlotOverridesSchema,
  targetSlotParticipantConditionsSchema,
  targetSlotRequirementsSchema,
  targetSlotSnapshotSchema,
  taxIncomeBulkQuerySchema,
  taxIncomeSummaryQuerySchema,
  teamBudgetTypeCoef,
  teamDifficultyPricingSchema,
  teamOpsAttendanceBulkEntrySchema,
  teamOpsAttendanceBulkQuerySchema,
  teamOpsAttendanceBulkResponseSchema,
  teamOpsAttendanceSourceSchema,
  teamOpsAttendanceStatusSchema,
  teamOpsReadScopeSchema,
  teamOpsRosterFiltersSchema,
  teamOpsRosterMembershipSchema,
  teamOpsRosterQuerySchema,
  teamOpsRosterResponseSchema,
  teamOpsRosterTeamSchema,
  teamOpsRosterVisibilitySchema,
  teamOpsWorklogDaySchema,
  teamOpsWorklogMonitoringEntrySchema,
  teamOpsWorklogMonitoringQuerySchema,
  teamOpsWorklogMonitoringResponseSchema,
  teamOpsWorklogTaskSchema,
  teamScheduleQuerySchema,
  telemetryEventNameSchema,
  telemetryObservationMetricSchema,
  telemetryObservationOutcomeSchema,
  telemetryObservationQuerySchema,
  telemetryObservationQuestionDetailSchema,
  telemetryObservationQuestionSchema,
  telemetryObservationReviewSchema,
  telemetryObservationSnapshotSchema,
  telemetryObservationStatusSchema,
  telemetryPayloadSchema,
  titleSimilarity,
  toAttendancePolicy,
  toKstDateString,
  toKstParts,
  toKstTimeMinutes,
  toKstWorkDateString,
  toNotificationCategory,
  toParticipantConditions,
  toUtcDateString,
  toggleReactionSchema,
  trackingImportRequestSchema,
  transferLeadership,
  transferLeadershipSchema,
  transferOwnershipSchema,
  triggerOutbreak,
  unblockCreatorRelationSchema,
  unfilledOutreachVariables,
  ungrantableScopes,
  uniqueWikiLinkTargets,
  unlockActivity,
  unpricedQuestWhere,
  untagQuestFromScenario,
  updateAdcodeMetricsSchema,
  updateAdvertiser,
  updateAdvertiserContactSchema,
  updateAdvertiserSchema,
  updateAgentSchema,
  updateBoostingStageSchema,
  updateBugReportSchema,
  updateCampaignRetroDeadlineSchema,
  updateCampaignRosterEntrySchema,
  updateCampaignSlotConditionsSchema,
  updateChannelGroupSchema,
  updateChannelSchema,
  updateCheckpoint,
  updateCheckpointSchema,
  updateConversationEntitySchema,
  updateConversationSchema,
  updateDayScheduleSchema,
  updateDropSignalStatusSchema,
  updateEmailSchema,
  updateExcludeFromAttendanceSchema,
  updateFeedSchema,
  updateHireDateSchema,
  updateHolidaySchema,
  updateIssueReportStatusSchema,
  updateLevelSchema,
  updateOnboardingGuideSchema,
  updatePieceworkActivitySchema,
  updatePointsSchema,
  updateProduct,
  updateProductSchema,
  updateProofDraft,
  updateProofDraftSchema,
  updateQuestSchema,
  updateQuestTask,
  updateQuestTaskSchema,
  updateQuestTemplate,
  updateQuestTemplateSchema,
  updateReplyTemplateSchema,
  updateReservationAttendeesSchema,
  updateReservationSchema,
  updateRolesSchema,
  updateRoomSchema,
  updateScenario,
  updateScenarioOutreachFormSchema,
  updateScenarioProduct,
  updateScenarioProductSchema,
  updateScenarioSchema,
  updateScenarioTemplateSchema,
  updateSeedingTeamIdsSchema,
  updateSettingsSchema,
  updateShortLinkSchema,
  updateTargetSlotOverridesSchema,
  updateTargetSlotParticipantSchema,
  updateTeamCapabilities,
  updateTeamCapabilitiesSchema,
  updateTeamSchema,
  updateTeamSettingsSchema,
  updateTimelineEventSchema,
  updateWikiAreaSchema,
  updateWikiDocumentSchema,
  updateWikiDocumentToolSchema,
  updateWikiSectionSchema,
  updateWorkLog,
  updateWorkLogSchema,
  updateWorkTypeSchema,
  upsertCreatorRelationPiiSchema,
  upsertWorkScheduleSchema,
  usageDashboardQuerySchema,
  validateAdvertiserReviewModeChange,
  validateCampaignRetroDeadline,
  validateCampaignTimeline,
  validateCeoPolicyValue,
  validateCheckpointRewardBalanced,
  validateCheckpointRewardTotal,
  validateHalfDayRequest,
  validateLeaveBalance,
  validateMissedClockInTime,
  validateMissedClockOutTime,
  validateOriginalProvenance,
  validateQuestCreationIds,
  validateSegmentTimes,
  validateTimeOrder,
  validateTimelineAttachment,
  validateTimelineEvent,
  verifyIdentitySchema,
  verifyOtpSchema,
  verifyPasskeyRegistrationSchema,
  videoTrackingConfirmReplacementRequestSchema,
  videoTrackingConfirmRequestSchema,
  videoTrackingControlRequestSchema,
  videoTrackingCorrectLinkRequestSchema,
  videoTrackingErrorMessage,
  videoTrackingRegisterRequestSchema,
  videoVisibilityReviewSchema,
  visibleReportsForViewer,
  voidPayoutSchema,
  voteSchema,
  weeklySummaryQuerySchema,
  wikiAreaKeySchema,
  wikiByTitleQuerySchema,
  wikiDocumentMetricsSchema,
  wikiImageExtension,
  wikiImageFileFromSrc,
  wikiImageSrc,
  wikiMetricsSchema,
  wikiParentTitle,
  wikiRevisionGuardSchema,
  withdrawAcceptances,
  withdrawQuest,
  withdrawQuestSchema,
  worklogNudgeSchema
};
//# sourceMappingURL=index.mjs.map